"use strict";

function _interopDefault(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var React = require("react"),
    React__default = _interopDefault(React),
    PropTypes = _interopDefault(require("prop-types")),
    PIXI = require("pixi.js"),
    scheduler = require("scheduler"),
    scheduler__default = _interopDefault(scheduler);

function _typeof(e) {
  return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(e);
}

function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}

function _createClass(e, t, n) {
  return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e;
}

function _defineProperty(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function _extends() {
  return (_extends = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function _objectSpread(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {},
        r = Object.keys(n);
    "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
      return Object.getOwnPropertyDescriptor(n, e).enumerable;
    }))), r.forEach(function (t) {
      _defineProperty(e, t, n[t]);
    });
  }

  return e;
}

function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && _setPrototypeOf(e, t);
}

function _getPrototypeOf(e) {
  return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function _setPrototypeOf(e, t) {
  return (_setPrototypeOf = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _possibleConstructorReturn(e, t) {
  return !t || "object" != typeof t && "function" != typeof t ? _assertThisInitialized(e) : t;
}

function _slicedToArray(e, t) {
  return _arrayWithHoles(e) || _iterableToArrayLimit(e, t) || _nonIterableRest();
}

function _arrayWithHoles(e) {
  if (Array.isArray(e)) return e;
}

function _iterableToArrayLimit(e, t) {
  var n = [],
      r = !0,
      i = !1,
      l = void 0;

  try {
    for (var a, o = e[Symbol.iterator](); !(r = (a = o.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
      ;
    }
  } catch (e) {
    i = !0, l = e;
  } finally {
    try {
      r || null == o.return || o.return();
    } finally {
      if (i) throw l;
    }
  }

  return n;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var validateFormat = function validateFormat(e) {};

function invariant(e, t, n, r, i, l, a, o) {
  if (validateFormat(t), !e) {
    var u;
    if (void 0 === t) u = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
      var c = [n, r, i, l, a, o],
          s = 0;
      (u = new Error(t.replace(/%s/g, function () {
        return c[s++];
      }))).name = "Invariant Violation";
    }
    throw u.framesToPop = 1, u;
  }
}

var invariant_1 = invariant,
    INJECTED_TYPES = {};

function injectType(e, t) {
  return INJECTED_TYPES[e] = t, e;
}

function createInjectedTypeInstance(e, t, n, r) {
  var i;

  if (e in INJECTED_TYPES) {
    var l,
        a = INJECTED_TYPES[e];
    "function" == typeof a ? l = a : "function" == typeof a.customDisplayObject && (l = a.customDisplayObject), invariant_1(l, "Invalid Component injected to ReactPixiFiber: `%s`.", e), i = l(t), "function" == typeof a.customApplyProps && (i._customApplyProps = a.customApplyProps.bind({
      applyDisplayObjectProps: r.bind(null, i)
    })), "function" == typeof a.customDidAttach && (i._customDidAttach = a.customDidAttach), "function" == typeof a.customWillDetach && (i._customWillDetach = a.customWillDetach);
  }

  return i;
}

function isInjectedType(e) {
  return void 0 !== INJECTED_TYPES[e];
}

function CustomPIXIComponent(e, t) {
  return invariant_1("string" == typeof t, "Invalid argument `type` of type `%s` supplied to `CustomPIXIComponent`, expected `string`.", _typeof(t)), injectType(t, e);
}

var propTypes = {
  app: PropTypes.object.isRequired,
  children: PropTypes.node
},
    childContextTypes = {
  app: PropTypes.object
};

function createAppProvider() {
  if ("function" == typeof React__default.createContext) {
    null === exports.AppContext && (exports.AppContext = React__default.createContext(null));

    var e = function (e) {
      function t() {
        return _classCallCheck(this, t), _possibleConstructorReturn(this, _getPrototypeOf(t).apply(this, arguments));
      }

      return _inherits(t, React__default.Component), _createClass(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.app,
              n = e.children;
          return React__default.createElement(exports.AppContext.Provider, {
            value: t
          }, n);
        }
      }]), t;
    }();

    e.propTypes = propTypes;
    return {
      AppProvider: e,
      withApp: function withApp(e) {
        function t(t) {
          return React__default.createElement(exports.AppContext.Consumer, null, function (n) {
            return React__default.createElement(e, _extends({}, t, {
              app: n
            }));
          });
        }

        return t.displayName = "withApp(".concat(e, ")"), t;
      }
    };
  }

  var t = function (e) {
    function t() {
      return _classCallCheck(this, t), _possibleConstructorReturn(this, _getPrototypeOf(t).apply(this, arguments));
    }

    return _inherits(t, React__default.Component), _createClass(t, [{
      key: "getChildContext",
      value: function value() {
        return {
          app: this.props.app
        };
      }
    }, {
      key: "render",
      value: function value() {
        return this.props.children;
      }
    }]), t;
  }();

  t.propTypes = propTypes, t.childContextTypes = childContextTypes;
  return {
    AppProvider: t,
    withApp: function withApp(e) {
      function t(t, n) {
        return React__default.createElement(e, _extends({}, t, {
          app: n.app
        }));
      }

      return t.displayName = "withApp(".concat(e, ")"), t.contextTypes = childContextTypes, t;
    }
  };
}

exports.AppContext = null;

var _createAppProvider = createAppProvider(),
    AppProvider = _createAppProvider.AppProvider,
    withApp = _createAppProvider.withApp;

function makeEmptyFunction(e) {
  return function () {
    return e;
  };
}

var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction, emptyFunction.thatReturnsFalse = makeEmptyFunction(!1), emptyFunction.thatReturnsTrue = makeEmptyFunction(!0), emptyFunction.thatReturnsNull = makeEmptyFunction(null), emptyFunction.thatReturnsThis = function () {
  return this;
}, emptyFunction.thatReturnsArgument = function (e) {
  return e;
};

var emptyFunction_1 = emptyFunction,
    warning = emptyFunction_1,
    warning_1 = warning,
    CHILDREN = "children",
    RESERVED_PROPS = _defineProperty({}, CHILDREN, !0),
    DEFAULT_PROPS = {
  alpha: 1,
  buttonMode: !1,
  cacheAsBitmap: !1,
  cursor: "auto",
  filterArea: null,
  filters: null,
  hitArea: null,
  interactive: !1,
  mask: null,
  pivot: 0,
  position: 0,
  renderable: !0,
  rotation: 0,
  scale: 1,
  skew: 0,
  transform: null,
  visible: !0,
  x: 0,
  y: 0
},
    EVENT_PROPS = ["added", "removed", "click", "mousedown", "mousemove", "mouseout", "mouseover", "mouseup", "mouseupoutside", "pointercancel", "pointerdown", "pointermove", "pointerout", "pointerover", "pointertap", "pointerup", "pointerupoutside", "rightclick", "rightdown", "rightup", "rightupoutside", "tap", "touchcancel", "touchend", "touchendoutside", "touchmove", "touchstart"],
    not = function not(e) {
  return function () {
    return !e.apply(void 0, arguments);
  };
},
    including = function including(e) {
  return function (t) {
    return -1 !== e.indexOf(t);
  };
},
    unique = function unique(e, t, n) {
  return n.indexOf(e) === t;
};

function filterByKey(e, t) {
  var n = {};
  return Object.keys(e).filter(t).forEach(function (t) {
    n[t] = e[t];
  }), n;
}

var includingReservedProps = including(Object.keys(RESERVED_PROPS));

function createPixiApplication(e) {
  return new PIXI.Application(e);
}

function parsePoint(e) {
  var t = [];
  return void 0 === e ? t : ("string" == typeof e ? t = e.split(",") : "number" == typeof e ? t = [e] : Array.isArray(e) ? t = e.slice() : void 0 !== e.x && void 0 !== e.y && (t = [e.x, e.y]), t.map(Number));
}

function isPointType(e) {
  return e instanceof PIXI.Point || e instanceof PIXI.ObservablePoint;
}

function copyPoint(e, t, n) {
  "function" == typeof e[t].copyFrom ? e[t].copyFrom(n) : e[t].copy(n);
}

function setPixiValue(e, t, n) {
  if (isPointType(e[t]) && isPointType(n)) copyPoint(e, t, n);else if (isPointType(e[t])) {
    var r = parsePoint(n);
    invariant_1(void 0 !== r && r.length > 0 && r.length < 3, "The property `%s` is a PIXI.Point or PIXI.ObservablePoint and must be set to a comma-separated string of either 1 or 2 coordinates, a 1 or 2 element array containing coordinates, or a PIXI Point/ObservablePoint. If only one coordinate is given then X and Y will be set to the provided value. Received: `%s` of type `%s`.", t, JSON.stringify(n), _typeof(n)), e[t].set(r.shift(), r.shift());
  } else e[t] = n;
}

function validateApp(e, t, n) {
  var r = e[t];

  if (void 0 !== r && (null != e.options && warning_1(!1, "'options' property of '".concat(n, "' has no effect when 'app' property is provided. Only use 'app' or 'options', never both.")), !(r instanceof PIXI.Application))) {
    var i = _typeof(r);

    return new Error("Invalid prop '".concat(t, "' of type '").concat(i, "' supplied to '").concat(n, "', expected 'PIXI.Application'."));
  }
}

function validateCanvas(e, t, n) {
  var r = e[t];

  if (void 0 !== r && !(r instanceof Element && "function" == typeof r.getContext)) {
    var i = _typeof(r);

    return new Error("Invalid prop '".concat(t, "' of type '").concat(i, "' supplied to '").concat(n, "', expected '<canvas> Element'."));
  }
}

var warned = {};

function deprecated(e, t) {
  return function (n, r, i) {
    if (null != n[r]) {
      var l = '"'.concat(r, '" property of "').concat(i, '" has been deprecated.\n').concat(t);
      warned[l] || (warning_1(!1, l), warned[l] = !0);
    }

    for (var a = arguments.length, o = new Array(a > 3 ? a - 3 : 0), u = 3; u < a; u++) {
      o[u - 3] = arguments[u];
    }

    return e.apply(void 0, [n, r, i].concat(o));
  };
}

var propTypes$1 = {
  app: validateApp,
  options: PropTypes.shape({
    antialias: PropTypes.bool,
    autoStart: PropTypes.bool,
    backgroundColor: PropTypes.number,
    clearBeforeRender: PropTypes.bool,
    forceCanvas: PropTypes.bool,
    forceFXAA: PropTypes.bool,
    height: PropTypes.number,
    legacy: PropTypes.bool,
    powerPreference: PropTypes.string,
    preserveDrawingBuffer: PropTypes.bool,
    resolution: PropTypes.number,
    roundPixels: PropTypes.bool,
    sharedLoader: PropTypes.bool,
    sharedTicker: PropTypes.bool,
    transparent: PropTypes.bool,
    view: validateCanvas,
    width: PropTypes.number
  }),
  children: PropTypes.node,
  height: deprecated(PropTypes.number, "Pass `height` in `options` prop instead."),
  width: deprecated(PropTypes.number, "Pass `height` in `options` prop instead.")
},
    includingDisplayObjectProps = including(Object.keys(DEFAULT_PROPS).concat(EVENT_PROPS)),
    includingStageProps = including(Object.keys(propTypes$1)),
    includingCanvasProps = function includingCanvasProps(e) {
  return !includingDisplayObjectProps(e) && !includingStageProps(e);
},
    getCanvasProps = function getCanvasProps(e) {
  return filterByKey(e, includingCanvasProps);
},
    getDisplayObjectProps = function getDisplayObjectProps(e) {
  return filterByKey(e, includingDisplayObjectProps);
};

function getDevToolsVersion() {
  return require("react").version;
}

var roots = new Map();

function createRender(e) {
  return function (t, n, r, i) {
    var l = roots.get(n);
    return l || (l = e.createContainer(n), roots.set(n, l), e.injectIntoDevTools({
      findFiberByHostInstance: e.findFiberByHostInstance,
      bundleType: 0,
      version: getDevToolsVersion(),
      rendererPackageName: "react-pixi-fiber"
    })), e.updateContainer(t, l, i, r), e.getPublicRootInstance(l);
  };
}

function createUnmount(e) {
  return function (t) {
    var n = roots.get(t);
    invariant_1(n, "ReactPixiFiber did not render into container provided"), e.updateContainer(null, n);
  };
}

var commonjsGlobal = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function createCommonjsModule(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}

var getOwnPropertySymbols = Object.getOwnPropertySymbols,
    hasOwnProperty = Object.prototype.hasOwnProperty,
    propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(e) {
  if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}

function shouldUseNative() {
  try {
    if (!Object.assign) return !1;
    var e = new String("abc");
    if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

    for (var t = {}, n = 0; n < 10; n++) {
      t["_" + String.fromCharCode(n)] = n;
    }

    if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
      return t[e];
    }).join("")) return !1;
    var r = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (e) {
      r[e] = e;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
  } catch (e) {
    return !1;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (e, t) {
  for (var n, r, i = toObject(e), l = 1; l < arguments.length; l++) {
    for (var a in n = Object(arguments[l])) {
      hasOwnProperty.call(n, a) && (i[a] = n[a]);
    }

    if (getOwnPropertySymbols) {
      r = getOwnPropertySymbols(n);

      for (var o = 0; o < r.length; o++) {
        propIsEnumerable.call(n, r[o]) && (i[r[o]] = n[r[o]]);
      }
    }
  }

  return i;
},
    reactReconciler_production_min = createCommonjsModule(function (e) {
  e.exports = function t(n) {
    var r = objectAssign,
        i = React__default,
        l = scheduler__default;

    function a(e) {
      for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++) {
        t += "&args[]=" + encodeURIComponent(arguments[n]);
      }

      return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }

    var o = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    o.hasOwnProperty("ReactCurrentDispatcher") || (o.ReactCurrentDispatcher = {
      current: null
    }), o.hasOwnProperty("ReactCurrentBatchConfig") || (o.ReactCurrentBatchConfig = {
      suspense: null
    });
    var u = "function" == typeof Symbol && Symbol.for,
        c = u ? Symbol.for("react.element") : 60103,
        s = u ? Symbol.for("react.portal") : 60106,
        f = u ? Symbol.for("react.fragment") : 60107,
        d = u ? Symbol.for("react.strict_mode") : 60108,
        p = u ? Symbol.for("react.profiler") : 60114,
        m = u ? Symbol.for("react.provider") : 60109,
        h = u ? Symbol.for("react.context") : 60110,
        g = u ? Symbol.for("react.concurrent_mode") : 60111,
        y = u ? Symbol.for("react.forward_ref") : 60112,
        v = u ? Symbol.for("react.suspense") : 60113,
        b = u ? Symbol.for("react.suspense_list") : 60120,
        T = u ? Symbol.for("react.memo") : 60115,
        x = u ? Symbol.for("react.lazy") : 60116,
        P = u ? Symbol.for("react.block") : 60121,
        E = "function" == typeof Symbol && Symbol.iterator;

    function S(e) {
      return null === e || "object" != typeof e ? null : "function" == typeof (e = E && e[E] || e["@@iterator"]) ? e : null;
    }

    function w(e) {
      if (null == e) return null;
      if ("function" == typeof e) return e.displayName || e.name || null;
      if ("string" == typeof e) return e;

      switch (e) {
        case f:
          return "Fragment";

        case s:
          return "Portal";

        case p:
          return "Profiler";

        case d:
          return "StrictMode";

        case v:
          return "Suspense";

        case b:
          return "SuspenseList";
      }

      if ("object" == typeof e) switch (e.$$typeof) {
        case h:
          return "Context.Consumer";

        case m:
          return "Context.Provider";

        case y:
          var t = e.render;
          return t = t.displayName || t.name || "", e.displayName || ("" !== t ? "ForwardRef(" + t + ")" : "ForwardRef");

        case T:
          return w(e.type);

        case P:
          return w(e.render);

        case x:
          if (e = 1 === e._status ? e._result : null) return w(e);
      }
      return null;
    }

    function C(e) {
      var t = e,
          n = e;
      if (e.alternate) for (; t.return;) {
        t = t.return;
      } else {
        e = t;

        do {
          0 != (1026 & (t = e).effectTag) && (n = t.return), e = t.return;
        } while (e);
      }
      return 3 === t.tag ? n : null;
    }

    function _(e) {
      if (C(e) !== e) throw Error(a(188));
    }

    function k(e) {
      var t = e.alternate;

      if (!t) {
        if (null === (t = C(e))) throw Error(a(188));
        return t !== e ? null : e;
      }

      for (var n = e, r = t;;) {
        var i = n.return;
        if (null === i) break;
        var l = i.alternate;

        if (null === l) {
          if (null !== (r = i.return)) {
            n = r;
            continue;
          }

          break;
        }

        if (i.child === l.child) {
          for (l = i.child; l;) {
            if (l === n) return _(i), e;
            if (l === r) return _(i), t;
            l = l.sibling;
          }

          throw Error(a(188));
        }

        if (n.return !== r.return) n = i, r = l;else {
          for (var o = !1, u = i.child; u;) {
            if (u === n) {
              o = !0, n = i, r = l;
              break;
            }

            if (u === r) {
              o = !0, r = i, n = l;
              break;
            }

            u = u.sibling;
          }

          if (!o) {
            for (u = l.child; u;) {
              if (u === n) {
                o = !0, n = l, r = i;
                break;
              }

              if (u === r) {
                o = !0, r = l, n = i;
                break;
              }

              u = u.sibling;
            }

            if (!o) throw Error(a(189));
          }
        }
        if (n.alternate !== r) throw Error(a(190));
      }

      if (3 !== n.tag) throw Error(a(188));
      return n.stateNode.current === n ? e : t;
    }

    function I(e) {
      if (!(e = k(e))) return null;

      for (var t = e;;) {
        if (5 === t.tag || 6 === t.tag) return t;
        if (t.child) t.child.return = t, t = t.child;else {
          if (t === e) break;

          for (; !t.sibling;) {
            if (!t.return || t.return === e) return null;
            t = t.return;
          }

          t.sibling.return = t.return, t = t.sibling;
        }
      }

      return null;
    }

    var R = n.getPublicInstance,
        N = n.getRootHostContext,
        z = n.getChildHostContext,
        A = n.prepareForCommit,
        O = n.resetAfterCommit,
        j = n.createInstance,
        D = n.appendInitialChild,
        F = n.finalizeInitialChildren,
        U = n.prepareUpdate,
        M = n.shouldSetTextContent,
        Q = n.shouldDeprioritizeSubtree,
        L = n.createTextInstance,
        H = n.setTimeout,
        W = n.clearTimeout,
        B = n.noTimeout,
        X = n.isPrimaryRenderer,
        q = n.supportsMutation,
        $ = n.supportsPersistence,
        V = n.supportsHydration,
        Y = n.appendChild,
        K = n.appendChildToContainer,
        G = n.commitTextUpdate,
        J = n.commitMount,
        Z = n.commitUpdate,
        ee = n.insertBefore,
        te = n.insertInContainerBefore,
        ne = n.removeChild,
        re = n.removeChildFromContainer,
        ie = n.resetTextContent,
        le = n.hideInstance,
        ae = n.hideTextInstance,
        oe = n.unhideInstance,
        ue = n.unhideTextInstance,
        ce = n.cloneInstance,
        se = n.createContainerChildSet,
        fe = n.appendChildToContainerChildSet,
        de = n.finalizeContainerChildren,
        pe = n.replaceContainerChildren,
        me = n.cloneHiddenInstance,
        he = n.cloneHiddenTextInstance,
        ge = n.canHydrateInstance,
        ye = n.canHydrateTextInstance,
        ve = n.isSuspenseInstancePending,
        be = n.isSuspenseInstanceFallback,
        Te = n.getNextHydratableSibling,
        xe = n.getFirstHydratableChild,
        Pe = n.hydrateInstance,
        Ee = n.hydrateTextInstance,
        Se = n.getNextHydratableInstanceAfterSuspenseInstance,
        we = n.commitHydratedContainer,
        Ce = n.commitHydratedSuspenseInstance,
        _e = /^(.*)[\\\/]/;

    function ke(e) {
      var t = "";

      do {
        e: switch (e.tag) {
          case 3:
          case 4:
          case 6:
          case 7:
          case 10:
          case 9:
            var n = "";
            break e;

          default:
            var r = e._debugOwner,
                i = e._debugSource,
                l = w(e.type);
            n = null, r && (n = w(r.type)), r = l, l = "", i ? l = " (at " + i.fileName.replace(_e, "") + ":" + i.lineNumber + ")" : n && (l = " (created by " + n + ")"), n = "\n    in " + (r || "Unknown") + l;
        }

        t += n, e = e.return;
      } while (e);

      return t;
    }

    var Ie = [],
        Re = -1;

    function Ne(e) {
      0 > Re || (e.current = Ie[Re], Ie[Re] = null, Re--);
    }

    function ze(e, t) {
      Ie[++Re] = e.current, e.current = t;
    }

    var Ae = {},
        Oe = {
      current: Ae
    },
        je = {
      current: !1
    },
        De = Ae;

    function Fe(e, t) {
      var n = e.type.contextTypes;
      if (!n) return Ae;
      var r = e.stateNode;
      if (r && r.__reactInternalMemoizedUnmaskedChildContext === t) return r.__reactInternalMemoizedMaskedChildContext;
      var i,
          l = {};

      for (i in n) {
        l[i] = t[i];
      }

      return r && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = t, e.__reactInternalMemoizedMaskedChildContext = l), l;
    }

    function Ue(e) {
      return null != (e = e.childContextTypes);
    }

    function Me() {
      Ne(je), Ne(Oe);
    }

    function Qe(e, t, n) {
      if (Oe.current !== Ae) throw Error(a(168));
      ze(Oe, t), ze(je, n);
    }

    function Le(e, t, n) {
      var i = e.stateNode;
      if (e = t.childContextTypes, "function" != typeof i.getChildContext) return n;

      for (var l in i = i.getChildContext()) {
        if (!(l in e)) throw Error(a(108, w(t) || "Unknown", l));
      }

      return r({}, n, {}, i);
    }

    function He(e) {
      return e = (e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext || Ae, De = Oe.current, ze(Oe, e), ze(je, je.current), !0;
    }

    function We(e, t, n) {
      var r = e.stateNode;
      if (!r) throw Error(a(169));
      n ? (e = Le(e, t, De), r.__reactInternalMemoizedMergedChildContext = e, Ne(je), Ne(Oe), ze(Oe, e)) : Ne(je), ze(je, n);
    }

    var Be = l.unstable_runWithPriority,
        Xe = l.unstable_scheduleCallback,
        qe = l.unstable_cancelCallback,
        $e = l.unstable_requestPaint,
        Ve = l.unstable_now,
        Ye = l.unstable_getCurrentPriorityLevel,
        Ke = l.unstable_ImmediatePriority,
        Ge = l.unstable_UserBlockingPriority,
        Je = l.unstable_NormalPriority,
        Ze = l.unstable_LowPriority,
        et = l.unstable_IdlePriority,
        tt = {},
        nt = l.unstable_shouldYield,
        rt = void 0 !== $e ? $e : function () {},
        it = null,
        lt = null,
        at = !1,
        ot = Ve(),
        ut = 1e4 > ot ? Ve : function () {
      return Ve() - ot;
    };

    function ct() {
      switch (Ye()) {
        case Ke:
          return 99;

        case Ge:
          return 98;

        case Je:
          return 97;

        case Ze:
          return 96;

        case et:
          return 95;

        default:
          throw Error(a(332));
      }
    }

    function st(e) {
      switch (e) {
        case 99:
          return Ke;

        case 98:
          return Ge;

        case 97:
          return Je;

        case 96:
          return Ze;

        case 95:
          return et;

        default:
          throw Error(a(332));
      }
    }

    function ft(e, t) {
      return e = st(e), Be(e, t);
    }

    function dt(e, t, n) {
      return e = st(e), Xe(e, t, n);
    }

    function pt(e) {
      return null === it ? (it = [e], lt = Xe(Ke, ht)) : it.push(e), tt;
    }

    function mt() {
      if (null !== lt) {
        var e = lt;
        lt = null, qe(e);
      }

      ht();
    }

    function ht() {
      if (!at && null !== it) {
        at = !0;
        var e = 0;

        try {
          var t = it;
          ft(99, function () {
            for (; e < t.length; e++) {
              var n = t[e];

              do {
                n = n(!0);
              } while (null !== n);
            }
          }), it = null;
        } catch (t) {
          throw null !== it && (it = it.slice(e + 1)), Xe(Ke, mt), t;
        } finally {
          at = !1;
        }
      }
    }

    function gt(e, t, n) {
      return 1073741821 - (1 + ((1073741821 - e + t / 10) / (n /= 10) | 0)) * n;
    }

    var yt = "function" == typeof Object.is ? Object.is : function (e, t) {
      return e === t && (0 !== e || 1 / e == 1 / t) || e != e && t != t;
    },
        vt = Object.prototype.hasOwnProperty;

    function bt(e, t) {
      if (yt(e, t)) return !0;
      if ("object" != typeof e || null === e || "object" != typeof t || null === t) return !1;
      var n = Object.keys(e),
          r = Object.keys(t);
      if (n.length !== r.length) return !1;

      for (r = 0; r < n.length; r++) {
        if (!vt.call(t, n[r]) || !yt(e[n[r]], t[n[r]])) return !1;
      }

      return !0;
    }

    function Tt(e, t) {
      if (e && e.defaultProps) for (var n in t = r({}, t), e = e.defaultProps) {
        void 0 === t[n] && (t[n] = e[n]);
      }
      return t;
    }

    var xt = {
      current: null
    },
        Pt = null,
        Et = null,
        St = null;

    function wt() {
      St = Et = Pt = null;
    }

    function Ct(e, t) {
      e = e.type._context, X ? (ze(xt, e._currentValue), e._currentValue = t) : (ze(xt, e._currentValue2), e._currentValue2 = t);
    }

    function _t(e) {
      var t = xt.current;
      Ne(xt), e = e.type._context, X ? e._currentValue = t : e._currentValue2 = t;
    }

    function kt(e, t) {
      for (; null !== e;) {
        var n = e.alternate;
        if (e.childExpirationTime < t) e.childExpirationTime = t, null !== n && n.childExpirationTime < t && (n.childExpirationTime = t);else {
          if (!(null !== n && n.childExpirationTime < t)) break;
          n.childExpirationTime = t;
        }
        e = e.return;
      }
    }

    function It(e, t) {
      Pt = e, St = Et = null, null !== (e = e.dependencies) && null !== e.firstContext && (e.expirationTime >= t && (rr = !0), e.firstContext = null);
    }

    function Rt(e, t) {
      if (St !== e && !1 !== t && 0 !== t) if ("number" == typeof t && 1073741823 !== t || (St = e, t = 1073741823), t = {
        context: e,
        observedBits: t,
        next: null
      }, null === Et) {
        if (null === Pt) throw Error(a(308));
        Et = t, Pt.dependencies = {
          expirationTime: 0,
          firstContext: t,
          responders: null
        };
      } else Et = Et.next = t;
      return X ? e._currentValue : e._currentValue2;
    }

    var Nt = !1;

    function zt(e) {
      e.updateQueue = {
        baseState: e.memoizedState,
        baseQueue: null,
        shared: {
          pending: null
        },
        effects: null
      };
    }

    function At(e, t) {
      e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
        baseState: e.baseState,
        baseQueue: e.baseQueue,
        shared: e.shared,
        effects: e.effects
      });
    }

    function Ot(e, t) {
      return (e = {
        expirationTime: e,
        suspenseConfig: t,
        tag: 0,
        payload: null,
        callback: null,
        next: null
      }).next = e;
    }

    function jt(e, t) {
      if (null !== (e = e.updateQueue)) {
        var n = (e = e.shared).pending;
        null === n ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
      }
    }

    function Dt(e, t) {
      var n = e.alternate;
      null !== n && At(n, e), null === (n = (e = e.updateQueue).baseQueue) ? (e.baseQueue = t.next = t, t.next = t) : (t.next = n.next, n.next = t);
    }

    function Ft(e, t, n, i) {
      var l = e.updateQueue;
      Nt = !1;
      var a = l.baseQueue,
          o = l.shared.pending;

      if (null !== o) {
        if (null !== a) {
          var u = a.next;
          a.next = o.next, o.next = u;
        }

        a = o, l.shared.pending = null, null !== (u = e.alternate) && null !== (u = u.updateQueue) && (u.baseQueue = o);
      }

      if (null !== a) {
        u = a.next;
        var c = l.baseState,
            s = 0,
            f = null,
            d = null,
            p = null;
        if (null !== u) for (var m = u;;) {
          if ((o = m.expirationTime) < i) {
            var h = {
              expirationTime: m.expirationTime,
              suspenseConfig: m.suspenseConfig,
              tag: m.tag,
              payload: m.payload,
              callback: m.callback,
              next: null
            };
            null === p ? (d = p = h, f = c) : p = p.next = h, o > s && (s = o);
          } else {
            null !== p && (p = p.next = {
              expirationTime: 1073741823,
              suspenseConfig: m.suspenseConfig,
              tag: m.tag,
              payload: m.payload,
              callback: m.callback,
              next: null
            }), Bi(o, m.suspenseConfig);

            e: {
              var g = e,
                  y = m;

              switch (o = t, h = n, y.tag) {
                case 1:
                  if ("function" == typeof (g = y.payload)) {
                    c = g.call(h, c, o);
                    break e;
                  }

                  c = g;
                  break e;

                case 3:
                  g.effectTag = -4097 & g.effectTag | 64;

                case 0:
                  if (null == (o = "function" == typeof (g = y.payload) ? g.call(h, c, o) : g)) break e;
                  c = r({}, c, o);
                  break e;

                case 2:
                  Nt = !0;
              }
            }

            null !== m.callback && (e.effectTag |= 32, null === (o = l.effects) ? l.effects = [m] : o.push(m));
          }

          if (null === (m = m.next) || m === u) {
            if (null === (o = l.shared.pending)) break;
            m = a.next = o.next, o.next = u, l.baseQueue = a = o, l.shared.pending = null;
          }
        }
        null === p ? f = c : p.next = d, l.baseState = f, l.baseQueue = p, Xi(s), e.expirationTime = s, e.memoizedState = c;
      }
    }

    function Ut(e, t, n) {
      if (e = t.effects, t.effects = null, null !== e) for (t = 0; t < e.length; t++) {
        var r = e[t],
            i = r.callback;

        if (null !== i) {
          if (r.callback = null, r = i, i = n, "function" != typeof r) throw Error(a(191, r));
          r.call(i);
        }
      }
    }

    var Mt = o.ReactCurrentBatchConfig,
        Qt = new i.Component().refs;

    function Lt(e, t, n, i) {
      n = null == (n = n(i, t = e.memoizedState)) ? t : r({}, t, n), e.memoizedState = n, 0 === e.expirationTime && (e.updateQueue.baseState = n);
    }

    var Ht = {
      isMounted: function isMounted(e) {
        return !!(e = e._reactInternalFiber) && C(e) === e;
      },
      enqueueSetState: function enqueueSetState(e, t, n) {
        e = e._reactInternalFiber;
        var r = zi(),
            i = Mt.suspense;
        (i = Ot(r = Ai(r, e, i), i)).payload = t, null != n && (i.callback = n), jt(e, i), Oi(e, r);
      },
      enqueueReplaceState: function enqueueReplaceState(e, t, n) {
        e = e._reactInternalFiber;
        var r = zi(),
            i = Mt.suspense;
        (i = Ot(r = Ai(r, e, i), i)).tag = 1, i.payload = t, null != n && (i.callback = n), jt(e, i), Oi(e, r);
      },
      enqueueForceUpdate: function enqueueForceUpdate(e, t) {
        e = e._reactInternalFiber;
        var n = zi(),
            r = Mt.suspense;
        (r = Ot(n = Ai(n, e, r), r)).tag = 2, null != t && (r.callback = t), jt(e, r), Oi(e, n);
      }
    };

    function Wt(e, t, n, r, i, l, a) {
      return "function" == typeof (e = e.stateNode).shouldComponentUpdate ? e.shouldComponentUpdate(r, l, a) : !t.prototype || !t.prototype.isPureReactComponent || !bt(n, r) || !bt(i, l);
    }

    function Bt(e, t, n) {
      var r = !1,
          i = Ae,
          l = t.contextType;
      return "object" == typeof l && null !== l ? l = Rt(l) : (i = Ue(t) ? De : Oe.current, l = (r = null != (r = t.contextTypes)) ? Fe(e, i) : Ae), t = new t(n, l), e.memoizedState = null !== t.state && void 0 !== t.state ? t.state : null, t.updater = Ht, e.stateNode = t, t._reactInternalFiber = e, r && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = i, e.__reactInternalMemoizedMaskedChildContext = l), t;
    }

    function Xt(e, t, n, r) {
      e = t.state, "function" == typeof t.componentWillReceiveProps && t.componentWillReceiveProps(n, r), "function" == typeof t.UNSAFE_componentWillReceiveProps && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && Ht.enqueueReplaceState(t, t.state, null);
    }

    function qt(e, t, n, r) {
      var i = e.stateNode;
      i.props = n, i.state = e.memoizedState, i.refs = Qt, zt(e);
      var l = t.contextType;
      "object" == typeof l && null !== l ? i.context = Rt(l) : (l = Ue(t) ? De : Oe.current, i.context = Fe(e, l)), Ft(e, n, i, r), i.state = e.memoizedState, "function" == typeof (l = t.getDerivedStateFromProps) && (Lt(e, t, l, n), i.state = e.memoizedState), "function" == typeof t.getDerivedStateFromProps || "function" == typeof i.getSnapshotBeforeUpdate || "function" != typeof i.UNSAFE_componentWillMount && "function" != typeof i.componentWillMount || (t = i.state, "function" == typeof i.componentWillMount && i.componentWillMount(), "function" == typeof i.UNSAFE_componentWillMount && i.UNSAFE_componentWillMount(), t !== i.state && Ht.enqueueReplaceState(i, i.state, null), Ft(e, n, i, r), i.state = e.memoizedState), "function" == typeof i.componentDidMount && (e.effectTag |= 4);
    }

    var $t = Array.isArray;

    function Vt(e, t, n) {
      if (null !== (e = n.ref) && "function" != typeof e && "object" != typeof e) {
        if (n._owner) {
          if (n = n._owner) {
            if (1 !== n.tag) throw Error(a(309));
            var r = n.stateNode;
          }

          if (!r) throw Error(a(147, e));
          var i = "" + e;
          return null !== t && null !== t.ref && "function" == typeof t.ref && t.ref._stringRef === i ? t.ref : ((t = function t(e) {
            var t = r.refs;
            t === Qt && (t = r.refs = {}), null === e ? delete t[i] : t[i] = e;
          })._stringRef = i, t);
        }

        if ("string" != typeof e) throw Error(a(284));
        if (!n._owner) throw Error(a(290, e));
      }

      return e;
    }

    function Yt(e, t) {
      if ("textarea" !== e.type) throw Error(a(31, "[object Object]" === Object.prototype.toString.call(t) ? "object with keys {" + Object.keys(t).join(", ") + "}" : t, ""));
    }

    function Kt(e) {
      function t(t, n) {
        if (e) {
          var r = t.lastEffect;
          null !== r ? (r.nextEffect = n, t.lastEffect = n) : t.firstEffect = t.lastEffect = n, n.nextEffect = null, n.effectTag = 8;
        }
      }

      function n(n, r) {
        if (!e) return null;

        for (; null !== r;) {
          t(n, r), r = r.sibling;
        }

        return null;
      }

      function r(e, t) {
        for (e = new Map(); null !== t;) {
          null !== t.key ? e.set(t.key, t) : e.set(t.index, t), t = t.sibling;
        }

        return e;
      }

      function i(e, t) {
        return (e = sl(e, t)).index = 0, e.sibling = null, e;
      }

      function l(t, n, r) {
        return t.index = r, e ? null !== (r = t.alternate) ? (r = r.index) < n ? (t.effectTag = 2, n) : r : (t.effectTag = 2, n) : n;
      }

      function o(t) {
        return e && null === t.alternate && (t.effectTag = 2), t;
      }

      function u(e, t, n, r) {
        return null === t || 6 !== t.tag ? ((t = pl(n, e.mode, r)).return = e, t) : ((t = i(t, n)).return = e, t);
      }

      function d(e, t, n, r) {
        return null !== t && t.elementType === n.type ? ((r = i(t, n.props)).ref = Vt(e, t, n), r.return = e, r) : ((r = fl(n.type, n.key, n.props, null, e.mode, r)).ref = Vt(e, t, n), r.return = e, r);
      }

      function p(e, t, n, r) {
        return null === t || 4 !== t.tag || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? ((t = ml(n, e.mode, r)).return = e, t) : ((t = i(t, n.children || [])).return = e, t);
      }

      function m(e, t, n, r, l) {
        return null === t || 7 !== t.tag ? ((t = dl(n, e.mode, r, l)).return = e, t) : ((t = i(t, n)).return = e, t);
      }

      function h(e, t, n) {
        if ("string" == typeof t || "number" == typeof t) return (t = pl("" + t, e.mode, n)).return = e, t;

        if ("object" == typeof t && null !== t) {
          switch (t.$$typeof) {
            case c:
              return (n = fl(t.type, t.key, t.props, null, e.mode, n)).ref = Vt(e, null, t), n.return = e, n;

            case s:
              return (t = ml(t, e.mode, n)).return = e, t;
          }

          if ($t(t) || S(t)) return (t = dl(t, e.mode, n, null)).return = e, t;
          Yt(e, t);
        }

        return null;
      }

      function g(e, t, n, r) {
        var i = null !== t ? t.key : null;
        if ("string" == typeof n || "number" == typeof n) return null !== i ? null : u(e, t, "" + n, r);

        if ("object" == typeof n && null !== n) {
          switch (n.$$typeof) {
            case c:
              return n.key === i ? n.type === f ? m(e, t, n.props.children, r, i) : d(e, t, n, r) : null;

            case s:
              return n.key === i ? p(e, t, n, r) : null;
          }

          if ($t(n) || S(n)) return null !== i ? null : m(e, t, n, r, null);
          Yt(e, n);
        }

        return null;
      }

      function y(e, t, n, r, i) {
        if ("string" == typeof r || "number" == typeof r) return u(t, e = e.get(n) || null, "" + r, i);

        if ("object" == typeof r && null !== r) {
          switch (r.$$typeof) {
            case c:
              return e = e.get(null === r.key ? n : r.key) || null, r.type === f ? m(t, e, r.props.children, i, r.key) : d(t, e, r, i);

            case s:
              return p(t, e = e.get(null === r.key ? n : r.key) || null, r, i);
          }

          if ($t(r) || S(r)) return m(t, e = e.get(n) || null, r, i, null);
          Yt(t, r);
        }

        return null;
      }

      function v(i, a, o, u) {
        for (var c = null, s = null, f = a, d = a = 0, p = null; null !== f && d < o.length; d++) {
          f.index > d ? (p = f, f = null) : p = f.sibling;
          var m = g(i, f, o[d], u);

          if (null === m) {
            null === f && (f = p);
            break;
          }

          e && f && null === m.alternate && t(i, f), a = l(m, a, d), null === s ? c = m : s.sibling = m, s = m, f = p;
        }

        if (d === o.length) return n(i, f), c;

        if (null === f) {
          for (; d < o.length; d++) {
            null !== (f = h(i, o[d], u)) && (a = l(f, a, d), null === s ? c = f : s.sibling = f, s = f);
          }

          return c;
        }

        for (f = r(i, f); d < o.length; d++) {
          null !== (p = y(f, i, d, o[d], u)) && (e && null !== p.alternate && f.delete(null === p.key ? d : p.key), a = l(p, a, d), null === s ? c = p : s.sibling = p, s = p);
        }

        return e && f.forEach(function (e) {
          return t(i, e);
        }), c;
      }

      function b(i, o, u, c) {
        var s = S(u);
        if ("function" != typeof s) throw Error(a(150));
        if (null == (u = s.call(u))) throw Error(a(151));

        for (var f = s = null, d = o, p = o = 0, m = null, v = u.next(); null !== d && !v.done; p++, v = u.next()) {
          d.index > p ? (m = d, d = null) : m = d.sibling;
          var b = g(i, d, v.value, c);

          if (null === b) {
            null === d && (d = m);
            break;
          }

          e && d && null === b.alternate && t(i, d), o = l(b, o, p), null === f ? s = b : f.sibling = b, f = b, d = m;
        }

        if (v.done) return n(i, d), s;

        if (null === d) {
          for (; !v.done; p++, v = u.next()) {
            null !== (v = h(i, v.value, c)) && (o = l(v, o, p), null === f ? s = v : f.sibling = v, f = v);
          }

          return s;
        }

        for (d = r(i, d); !v.done; p++, v = u.next()) {
          null !== (v = y(d, i, p, v.value, c)) && (e && null !== v.alternate && d.delete(null === v.key ? p : v.key), o = l(v, o, p), null === f ? s = v : f.sibling = v, f = v);
        }

        return e && d.forEach(function (e) {
          return t(i, e);
        }), s;
      }

      return function (e, r, l, u) {
        var d = "object" == typeof l && null !== l && l.type === f && null === l.key;
        d && (l = l.props.children);
        var p = "object" == typeof l && null !== l;
        if (p) switch (l.$$typeof) {
          case c:
            e: {
              for (p = l.key, d = r; null !== d;) {
                if (d.key === p) {
                  switch (d.tag) {
                    case 7:
                      if (l.type === f) {
                        n(e, d.sibling), (r = i(d, l.props.children)).return = e, e = r;
                        break e;
                      }

                      break;

                    default:
                      if (d.elementType === l.type) {
                        n(e, d.sibling), (r = i(d, l.props)).ref = Vt(e, d, l), r.return = e, e = r;
                        break e;
                      }

                  }

                  n(e, d);
                  break;
                }

                t(e, d), d = d.sibling;
              }

              l.type === f ? ((r = dl(l.props.children, e.mode, u, l.key)).return = e, e = r) : ((u = fl(l.type, l.key, l.props, null, e.mode, u)).ref = Vt(e, r, l), u.return = e, e = u);
            }

            return o(e);

          case s:
            e: {
              for (d = l.key; null !== r;) {
                if (r.key === d) {
                  if (4 === r.tag && r.stateNode.containerInfo === l.containerInfo && r.stateNode.implementation === l.implementation) {
                    n(e, r.sibling), (r = i(r, l.children || [])).return = e, e = r;
                    break e;
                  }

                  n(e, r);
                  break;
                }

                t(e, r), r = r.sibling;
              }

              (r = ml(l, e.mode, u)).return = e, e = r;
            }

            return o(e);
        }
        if ("string" == typeof l || "number" == typeof l) return l = "" + l, null !== r && 6 === r.tag ? (n(e, r.sibling), (r = i(r, l)).return = e, e = r) : (n(e, r), (r = pl(l, e.mode, u)).return = e, e = r), o(e);
        if ($t(l)) return v(e, r, l, u);
        if (S(l)) return b(e, r, l, u);
        if (p && Yt(e, l), void 0 === l && !d) switch (e.tag) {
          case 1:
          case 0:
            throw e = e.type, Error(a(152, e.displayName || e.name || "Component"));
        }
        return n(e, r);
      };
    }

    var Gt = Kt(!0),
        Jt = Kt(!1),
        Zt = {},
        en = {
      current: Zt
    },
        tn = {
      current: Zt
    },
        nn = {
      current: Zt
    };

    function rn(e) {
      if (e === Zt) throw Error(a(174));
      return e;
    }

    function ln(e, t) {
      ze(nn, t), ze(tn, e), ze(en, Zt), e = N(t), Ne(en), ze(en, e);
    }

    function an() {
      Ne(en), Ne(tn), Ne(nn);
    }

    function on(e) {
      var t = rn(nn.current),
          n = rn(en.current);
      n !== (t = z(n, e.type, t)) && (ze(tn, e), ze(en, t));
    }

    function un(e) {
      tn.current === e && (Ne(en), Ne(tn));
    }

    var cn = {
      current: 0
    };

    function sn(e) {
      for (var t = e; null !== t;) {
        if (13 === t.tag) {
          var n = t.memoizedState;
          if (null !== n && (null === (n = n.dehydrated) || ve(n) || be(n))) return t;
        } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
          if (0 != (64 & t.effectTag)) return t;
        } else if (null !== t.child) {
          t.child.return = t, t = t.child;
          continue;
        }

        if (t === e) break;

        for (; null === t.sibling;) {
          if (null === t.return || t.return === e) return null;
          t = t.return;
        }

        t.sibling.return = t.return, t = t.sibling;
      }

      return null;
    }

    function fn(e, t) {
      return {
        responder: e,
        props: t
      };
    }

    var dn = o.ReactCurrentDispatcher,
        pn = o.ReactCurrentBatchConfig,
        mn = 0,
        hn = null,
        gn = null,
        yn = null,
        vn = !1;

    function bn() {
      throw Error(a(321));
    }

    function Tn(e, t) {
      if (null === t) return !1;

      for (var n = 0; n < t.length && n < e.length; n++) {
        if (!yt(e[n], t[n])) return !1;
      }

      return !0;
    }

    function xn(e, t, n, r, i, l) {
      if (mn = l, hn = t, t.memoizedState = null, t.updateQueue = null, t.expirationTime = 0, dn.current = null === e || null === e.memoizedState ? Bn : Xn, e = n(r, i), t.expirationTime === mn) {
        l = 0;

        do {
          if (t.expirationTime = 0, !(25 > l)) throw Error(a(301));
          l += 1, yn = gn = null, t.updateQueue = null, dn.current = qn, e = n(r, i);
        } while (t.expirationTime === mn);
      }

      if (dn.current = Wn, t = null !== gn && null !== gn.next, mn = 0, yn = gn = hn = null, vn = !1, t) throw Error(a(300));
      return e;
    }

    function Pn() {
      var e = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return null === yn ? hn.memoizedState = yn = e : yn = yn.next = e, yn;
    }

    function En() {
      if (null === gn) {
        var e = hn.alternate;
        e = null !== e ? e.memoizedState : null;
      } else e = gn.next;

      var t = null === yn ? hn.memoizedState : yn.next;
      if (null !== t) yn = t, gn = e;else {
        if (null === e) throw Error(a(310));
        e = {
          memoizedState: (gn = e).memoizedState,
          baseState: gn.baseState,
          baseQueue: gn.baseQueue,
          queue: gn.queue,
          next: null
        }, null === yn ? hn.memoizedState = yn = e : yn = yn.next = e;
      }
      return yn;
    }

    function Sn(e, t) {
      return "function" == typeof t ? t(e) : t;
    }

    function wn(e) {
      var t = En(),
          n = t.queue;
      if (null === n) throw Error(a(311));
      n.lastRenderedReducer = e;
      var r = gn,
          i = r.baseQueue,
          l = n.pending;

      if (null !== l) {
        if (null !== i) {
          var o = i.next;
          i.next = l.next, l.next = o;
        }

        r.baseQueue = i = l, n.pending = null;
      }

      if (null !== i) {
        i = i.next, r = r.baseState;
        var u = o = l = null,
            c = i;

        do {
          var s = c.expirationTime;

          if (s < mn) {
            var f = {
              expirationTime: c.expirationTime,
              suspenseConfig: c.suspenseConfig,
              action: c.action,
              eagerReducer: c.eagerReducer,
              eagerState: c.eagerState,
              next: null
            };
            null === u ? (o = u = f, l = r) : u = u.next = f, s > hn.expirationTime && (hn.expirationTime = s, Xi(s));
          } else null !== u && (u = u.next = {
            expirationTime: 1073741823,
            suspenseConfig: c.suspenseConfig,
            action: c.action,
            eagerReducer: c.eagerReducer,
            eagerState: c.eagerState,
            next: null
          }), Bi(s, c.suspenseConfig), r = c.eagerReducer === e ? c.eagerState : e(r, c.action);

          c = c.next;
        } while (null !== c && c !== i);

        null === u ? l = r : u.next = o, yt(r, t.memoizedState) || (rr = !0), t.memoizedState = r, t.baseState = l, t.baseQueue = u, n.lastRenderedState = r;
      }

      return [t.memoizedState, n.dispatch];
    }

    function Cn(e) {
      var t = En(),
          n = t.queue;
      if (null === n) throw Error(a(311));
      n.lastRenderedReducer = e;
      var r = n.dispatch,
          i = n.pending,
          l = t.memoizedState;

      if (null !== i) {
        n.pending = null;
        var o = i = i.next;

        do {
          l = e(l, o.action), o = o.next;
        } while (o !== i);

        yt(l, t.memoizedState) || (rr = !0), t.memoizedState = l, null === t.baseQueue && (t.baseState = l), n.lastRenderedState = l;
      }

      return [l, r];
    }

    function _n(e) {
      var t = Pn();
      return "function" == typeof e && (e = e()), t.memoizedState = t.baseState = e, e = (e = t.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Sn,
        lastRenderedState: e
      }).dispatch = Hn.bind(null, hn, e), [t.memoizedState, e];
    }

    function kn(e, t, n, r) {
      return e = {
        tag: e,
        create: t,
        destroy: n,
        deps: r,
        next: null
      }, null === (t = hn.updateQueue) ? (t = {
        lastEffect: null
      }, hn.updateQueue = t, t.lastEffect = e.next = e) : null === (n = t.lastEffect) ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e), e;
    }

    function In() {
      return En().memoizedState;
    }

    function Rn(e, t, n, r) {
      var i = Pn();
      hn.effectTag |= e, i.memoizedState = kn(1 | t, n, void 0, void 0 === r ? null : r);
    }

    function Nn(e, t, n, r) {
      var i = En();
      r = void 0 === r ? null : r;
      var l = void 0;

      if (null !== gn) {
        var a = gn.memoizedState;
        if (l = a.destroy, null !== r && Tn(r, a.deps)) return void kn(t, n, l, r);
      }

      hn.effectTag |= e, i.memoizedState = kn(1 | t, n, l, r);
    }

    function zn(e, t) {
      return Rn(516, 4, e, t);
    }

    function An(e, t) {
      return Nn(516, 4, e, t);
    }

    function On(e, t) {
      return Nn(4, 2, e, t);
    }

    function jn(e, t) {
      return "function" == typeof t ? (e = e(), t(e), function () {
        t(null);
      }) : null != t ? (e = e(), t.current = e, function () {
        t.current = null;
      }) : void 0;
    }

    function Dn(e, t, n) {
      return n = null != n ? n.concat([e]) : null, Nn(4, 2, jn.bind(null, t, e), n);
    }

    function Fn() {}

    function Un(e, t) {
      return Pn().memoizedState = [e, void 0 === t ? null : t], e;
    }

    function Mn(e, t) {
      var n = En();
      t = void 0 === t ? null : t;
      var r = n.memoizedState;
      return null !== r && null !== t && Tn(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
    }

    function Qn(e, t) {
      var n = En();
      t = void 0 === t ? null : t;
      var r = n.memoizedState;
      return null !== r && null !== t && Tn(t, r[1]) ? r[0] : (e = e(), n.memoizedState = [e, t], e);
    }

    function Ln(e, t, n) {
      var r = ct();
      ft(98 > r ? 98 : r, function () {
        e(!0);
      }), ft(97 < r ? 97 : r, function () {
        var r = pn.suspense;
        pn.suspense = void 0 === t ? null : t;

        try {
          e(!1), n();
        } finally {
          pn.suspense = r;
        }
      });
    }

    function Hn(e, t, n) {
      var r = zi(),
          i = Mt.suspense;
      i = {
        expirationTime: r = Ai(r, e, i),
        suspenseConfig: i,
        action: n,
        eagerReducer: null,
        eagerState: null,
        next: null
      };
      var l = t.pending;
      if (null === l ? i.next = i : (i.next = l.next, l.next = i), t.pending = i, l = e.alternate, e === hn || null !== l && l === hn) vn = !0, i.expirationTime = mn, hn.expirationTime = mn;else {
        if (0 === e.expirationTime && (null === l || 0 === l.expirationTime) && null !== (l = t.lastRenderedReducer)) try {
          var a = t.lastRenderedState,
              o = l(a, n);
          if (i.eagerReducer = l, i.eagerState = o, yt(o, a)) return;
        } catch (e) {}
        Oi(e, r);
      }
    }

    var Wn = {
      readContext: Rt,
      useCallback: bn,
      useContext: bn,
      useEffect: bn,
      useImperativeHandle: bn,
      useLayoutEffect: bn,
      useMemo: bn,
      useReducer: bn,
      useRef: bn,
      useState: bn,
      useDebugValue: bn,
      useResponder: bn,
      useDeferredValue: bn,
      useTransition: bn
    },
        Bn = {
      readContext: Rt,
      useCallback: Un,
      useContext: Rt,
      useEffect: zn,
      useImperativeHandle: function useImperativeHandle(e, t, n) {
        return n = null != n ? n.concat([e]) : null, Rn(4, 2, jn.bind(null, t, e), n);
      },
      useLayoutEffect: function useLayoutEffect(e, t) {
        return Rn(4, 2, e, t);
      },
      useMemo: function useMemo(e, t) {
        var n = Pn();
        return t = void 0 === t ? null : t, e = e(), n.memoizedState = [e, t], e;
      },
      useReducer: function useReducer(e, t, n) {
        var r = Pn();
        return t = void 0 !== n ? n(t) : t, r.memoizedState = r.baseState = t, e = (e = r.queue = {
          pending: null,
          dispatch: null,
          lastRenderedReducer: e,
          lastRenderedState: t
        }).dispatch = Hn.bind(null, hn, e), [r.memoizedState, e];
      },
      useRef: function useRef(e) {
        return e = {
          current: e
        }, Pn().memoizedState = e;
      },
      useState: _n,
      useDebugValue: Fn,
      useResponder: fn,
      useDeferredValue: function useDeferredValue(e, t) {
        var n = _n(e),
            r = n[0],
            i = n[1];

        return zn(function () {
          var n = pn.suspense;
          pn.suspense = void 0 === t ? null : t;

          try {
            i(e);
          } finally {
            pn.suspense = n;
          }
        }, [e, t]), r;
      },
      useTransition: function useTransition(e) {
        var t = _n(!1),
            n = t[0];

        return t = t[1], [Un(Ln.bind(null, t, e), [t, e]), n];
      }
    },
        Xn = {
      readContext: Rt,
      useCallback: Mn,
      useContext: Rt,
      useEffect: An,
      useImperativeHandle: Dn,
      useLayoutEffect: On,
      useMemo: Qn,
      useReducer: wn,
      useRef: In,
      useState: function useState() {
        return wn(Sn);
      },
      useDebugValue: Fn,
      useResponder: fn,
      useDeferredValue: function useDeferredValue(e, t) {
        var n = wn(Sn),
            r = n[0],
            i = n[1];
        return An(function () {
          var n = pn.suspense;
          pn.suspense = void 0 === t ? null : t;

          try {
            i(e);
          } finally {
            pn.suspense = n;
          }
        }, [e, t]), r;
      },
      useTransition: function useTransition(e) {
        var t = wn(Sn),
            n = t[0];
        return t = t[1], [Mn(Ln.bind(null, t, e), [t, e]), n];
      }
    },
        qn = {
      readContext: Rt,
      useCallback: Mn,
      useContext: Rt,
      useEffect: An,
      useImperativeHandle: Dn,
      useLayoutEffect: On,
      useMemo: Qn,
      useReducer: Cn,
      useRef: In,
      useState: function useState() {
        return Cn(Sn);
      },
      useDebugValue: Fn,
      useResponder: fn,
      useDeferredValue: function useDeferredValue(e, t) {
        var n = Cn(Sn),
            r = n[0],
            i = n[1];
        return An(function () {
          var n = pn.suspense;
          pn.suspense = void 0 === t ? null : t;

          try {
            i(e);
          } finally {
            pn.suspense = n;
          }
        }, [e, t]), r;
      },
      useTransition: function useTransition(e) {
        var t = Cn(Sn),
            n = t[0];
        return t = t[1], [Mn(Ln.bind(null, t, e), [t, e]), n];
      }
    },
        $n = null,
        Vn = null,
        Yn = !1;

    function Kn(e, t) {
      var n = ul(5, null, null, 0);
      n.elementType = "DELETED", n.type = "DELETED", n.stateNode = t, n.return = e, n.effectTag = 8, null !== e.lastEffect ? (e.lastEffect.nextEffect = n, e.lastEffect = n) : e.firstEffect = e.lastEffect = n;
    }

    function Gn(e, t) {
      switch (e.tag) {
        case 5:
          return null !== (t = ge(t, e.type, e.pendingProps)) && (e.stateNode = t, !0);

        case 6:
          return null !== (t = ye(t, e.pendingProps)) && (e.stateNode = t, !0);

        case 13:
        default:
          return !1;
      }
    }

    function Jn(e) {
      if (Yn) {
        var t = Vn;

        if (t) {
          var n = t;

          if (!Gn(e, t)) {
            if (!(t = Te(n)) || !Gn(e, t)) return e.effectTag = -1025 & e.effectTag | 2, Yn = !1, void ($n = e);
            Kn($n, n);
          }

          $n = e, Vn = xe(t);
        } else e.effectTag = -1025 & e.effectTag | 2, Yn = !1, $n = e;
      }
    }

    function Zn(e) {
      for (e = e.return; null !== e && 5 !== e.tag && 3 !== e.tag && 13 !== e.tag;) {
        e = e.return;
      }

      $n = e;
    }

    function er(e) {
      if (!V || e !== $n) return !1;
      if (!Yn) return Zn(e), Yn = !0, !1;
      var t = e.type;
      if (5 !== e.tag || "head" !== t && "body" !== t && !M(t, e.memoizedProps)) for (t = Vn; t;) {
        Kn(e, t), t = Te(t);
      }

      if (Zn(e), 13 === e.tag) {
        if (!V) throw Error(a(316));
        if (!(e = null !== (e = e.memoizedState) ? e.dehydrated : null)) throw Error(a(317));
        Vn = Se(e);
      } else Vn = $n ? Te(e.stateNode) : null;

      return !0;
    }

    function tr() {
      V && (Vn = $n = null, Yn = !1);
    }

    var nr = o.ReactCurrentOwner,
        rr = !1;

    function ir(e, t, n, r) {
      t.child = null === e ? Jt(t, null, n, r) : Gt(t, e.child, n, r);
    }

    function lr(e, t, n, r, i) {
      n = n.render;
      var l = t.ref;
      return It(t, i), r = xn(e, t, n, r, l, i), null === e || rr ? (t.effectTag |= 1, ir(e, t, r, i), t.child) : (t.updateQueue = e.updateQueue, t.effectTag &= -517, e.expirationTime <= i && (e.expirationTime = 0), Pr(e, t, i));
    }

    function ar(e, t, n, r, i, l) {
      if (null === e) {
        var a = n.type;
        return "function" != typeof a || cl(a) || void 0 !== a.defaultProps || null !== n.compare || void 0 !== n.defaultProps ? ((e = fl(n.type, null, r, null, t.mode, l)).ref = t.ref, e.return = t, t.child = e) : (t.tag = 15, t.type = a, or(e, t, a, r, i, l));
      }

      return a = e.child, i < l && (i = a.memoizedProps, (n = null !== (n = n.compare) ? n : bt)(i, r) && e.ref === t.ref) ? Pr(e, t, l) : (t.effectTag |= 1, (e = sl(a, r)).ref = t.ref, e.return = t, t.child = e);
    }

    function or(e, t, n, r, i, l) {
      return null !== e && bt(e.memoizedProps, r) && e.ref === t.ref && (rr = !1, i < l) ? (t.expirationTime = e.expirationTime, Pr(e, t, l)) : cr(e, t, n, r, l);
    }

    function ur(e, t) {
      var n = t.ref;
      (null === e && null !== n || null !== e && e.ref !== n) && (t.effectTag |= 128);
    }

    function cr(e, t, n, r, i) {
      var l = Ue(n) ? De : Oe.current;
      return l = Fe(t, l), It(t, i), n = xn(e, t, n, r, l, i), null === e || rr ? (t.effectTag |= 1, ir(e, t, n, i), t.child) : (t.updateQueue = e.updateQueue, t.effectTag &= -517, e.expirationTime <= i && (e.expirationTime = 0), Pr(e, t, i));
    }

    function sr(e, t, n, r, i) {
      if (Ue(n)) {
        var l = !0;
        He(t);
      } else l = !1;

      if (It(t, i), null === t.stateNode) null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), Bt(t, n, r), qt(t, n, r, i), r = !0;else if (null === e) {
        var a = t.stateNode,
            o = t.memoizedProps;
        a.props = o;
        var u = a.context,
            c = n.contextType;
        "object" == typeof c && null !== c ? c = Rt(c) : c = Fe(t, c = Ue(n) ? De : Oe.current);
        var s = n.getDerivedStateFromProps,
            f = "function" == typeof s || "function" == typeof a.getSnapshotBeforeUpdate;
        f || "function" != typeof a.UNSAFE_componentWillReceiveProps && "function" != typeof a.componentWillReceiveProps || (o !== r || u !== c) && Xt(t, a, r, c), Nt = !1;
        var d = t.memoizedState;
        a.state = d, Ft(t, r, a, i), u = t.memoizedState, o !== r || d !== u || je.current || Nt ? ("function" == typeof s && (Lt(t, n, s, r), u = t.memoizedState), (o = Nt || Wt(t, n, o, r, d, u, c)) ? (f || "function" != typeof a.UNSAFE_componentWillMount && "function" != typeof a.componentWillMount || ("function" == typeof a.componentWillMount && a.componentWillMount(), "function" == typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount()), "function" == typeof a.componentDidMount && (t.effectTag |= 4)) : ("function" == typeof a.componentDidMount && (t.effectTag |= 4), t.memoizedProps = r, t.memoizedState = u), a.props = r, a.state = u, a.context = c, r = o) : ("function" == typeof a.componentDidMount && (t.effectTag |= 4), r = !1);
      } else a = t.stateNode, At(e, t), o = t.memoizedProps, a.props = t.type === t.elementType ? o : Tt(t.type, o), u = a.context, "object" == typeof (c = n.contextType) && null !== c ? c = Rt(c) : c = Fe(t, c = Ue(n) ? De : Oe.current), (f = "function" == typeof (s = n.getDerivedStateFromProps) || "function" == typeof a.getSnapshotBeforeUpdate) || "function" != typeof a.UNSAFE_componentWillReceiveProps && "function" != typeof a.componentWillReceiveProps || (o !== r || u !== c) && Xt(t, a, r, c), Nt = !1, u = t.memoizedState, a.state = u, Ft(t, r, a, i), d = t.memoizedState, o !== r || u !== d || je.current || Nt ? ("function" == typeof s && (Lt(t, n, s, r), d = t.memoizedState), (s = Nt || Wt(t, n, o, r, u, d, c)) ? (f || "function" != typeof a.UNSAFE_componentWillUpdate && "function" != typeof a.componentWillUpdate || ("function" == typeof a.componentWillUpdate && a.componentWillUpdate(r, d, c), "function" == typeof a.UNSAFE_componentWillUpdate && a.UNSAFE_componentWillUpdate(r, d, c)), "function" == typeof a.componentDidUpdate && (t.effectTag |= 4), "function" == typeof a.getSnapshotBeforeUpdate && (t.effectTag |= 256)) : ("function" != typeof a.componentDidUpdate || o === e.memoizedProps && u === e.memoizedState || (t.effectTag |= 4), "function" != typeof a.getSnapshotBeforeUpdate || o === e.memoizedProps && u === e.memoizedState || (t.effectTag |= 256), t.memoizedProps = r, t.memoizedState = d), a.props = r, a.state = d, a.context = c, r = s) : ("function" != typeof a.componentDidUpdate || o === e.memoizedProps && u === e.memoizedState || (t.effectTag |= 4), "function" != typeof a.getSnapshotBeforeUpdate || o === e.memoizedProps && u === e.memoizedState || (t.effectTag |= 256), r = !1);
      return fr(e, t, n, r, l, i);
    }

    function fr(e, t, n, r, i, l) {
      ur(e, t);
      var a = 0 != (64 & t.effectTag);
      if (!r && !a) return i && We(t, n, !1), Pr(e, t, l);
      r = t.stateNode, nr.current = t;
      var o = a && "function" != typeof n.getDerivedStateFromError ? null : r.render();
      return t.effectTag |= 1, null !== e && a ? (t.child = Gt(t, e.child, null, l), t.child = Gt(t, null, o, l)) : ir(e, t, o, l), t.memoizedState = r.state, i && We(t, n, !0), t.child;
    }

    function dr(e) {
      var t = e.stateNode;
      t.pendingContext ? Qe(0, t.pendingContext, t.pendingContext !== t.context) : t.context && Qe(0, t.context, !1), ln(e, t.containerInfo);
    }

    var _pr,
        mr,
        hr,
        gr,
        yr = {
      dehydrated: null,
      retryTime: 0
    };

    function vr(e, t, n) {
      var r,
          i = t.mode,
          l = t.pendingProps,
          a = cn.current,
          o = !1;

      if ((r = 0 != (64 & t.effectTag)) || (r = 0 != (2 & a) && (null === e || null !== e.memoizedState)), r ? (o = !0, t.effectTag &= -65) : null !== e && null === e.memoizedState || void 0 === l.fallback || !0 === l.unstable_avoidThisFallback || (a |= 1), ze(cn, 1 & a), null === e) {
        if (void 0 !== l.fallback && Jn(t), o) {
          if (o = l.fallback, (l = dl(null, i, 0, null)).return = t, 0 == (2 & t.mode)) for (e = null !== t.memoizedState ? t.child.child : t.child, l.child = e; null !== e;) {
            e.return = l, e = e.sibling;
          }
          return (n = dl(o, i, n, null)).return = t, l.sibling = n, t.memoizedState = yr, t.child = l, n;
        }

        return i = l.children, t.memoizedState = null, t.child = Jt(t, null, i, n);
      }

      if (null !== e.memoizedState) {
        if (i = (e = e.child).sibling, o) {
          if (l = l.fallback, (n = sl(e, e.pendingProps)).return = t, 0 == (2 & t.mode) && (o = null !== t.memoizedState ? t.child.child : t.child) !== e.child) for (n.child = o; null !== o;) {
            o.return = n, o = o.sibling;
          }
          return (i = sl(i, l)).return = t, n.sibling = i, n.childExpirationTime = 0, t.memoizedState = yr, t.child = n, i;
        }

        return n = Gt(t, e.child, l.children, n), t.memoizedState = null, t.child = n;
      }

      if (e = e.child, o) {
        if (o = l.fallback, (l = dl(null, i, 0, null)).return = t, l.child = e, null !== e && (e.return = l), 0 == (2 & t.mode)) for (e = null !== t.memoizedState ? t.child.child : t.child, l.child = e; null !== e;) {
          e.return = l, e = e.sibling;
        }
        return (n = dl(o, i, n, null)).return = t, l.sibling = n, n.effectTag |= 2, l.childExpirationTime = 0, t.memoizedState = yr, t.child = l, n;
      }

      return t.memoizedState = null, t.child = Gt(t, e, l.children, n);
    }

    function br(e, t) {
      e.expirationTime < t && (e.expirationTime = t);
      var n = e.alternate;
      null !== n && n.expirationTime < t && (n.expirationTime = t), kt(e.return, t);
    }

    function Tr(e, t, n, r, i, l) {
      var a = e.memoizedState;
      null === a ? e.memoizedState = {
        isBackwards: t,
        rendering: null,
        renderingStartTime: 0,
        last: r,
        tail: n,
        tailExpiration: 0,
        tailMode: i,
        lastEffect: l
      } : (a.isBackwards = t, a.rendering = null, a.renderingStartTime = 0, a.last = r, a.tail = n, a.tailExpiration = 0, a.tailMode = i, a.lastEffect = l);
    }

    function xr(e, t, n) {
      var r = t.pendingProps,
          i = r.revealOrder,
          l = r.tail;
      if (ir(e, t, r.children, n), 0 != (2 & (r = cn.current))) r = 1 & r | 2, t.effectTag |= 64;else {
        if (null !== e && 0 != (64 & e.effectTag)) e: for (e = t.child; null !== e;) {
          if (13 === e.tag) null !== e.memoizedState && br(e, n);else if (19 === e.tag) br(e, n);else if (null !== e.child) {
            e.child.return = e, e = e.child;
            continue;
          }
          if (e === t) break e;

          for (; null === e.sibling;) {
            if (null === e.return || e.return === t) break e;
            e = e.return;
          }

          e.sibling.return = e.return, e = e.sibling;
        }
        r &= 1;
      }
      if (ze(cn, r), 0 == (2 & t.mode)) t.memoizedState = null;else switch (i) {
        case "forwards":
          for (n = t.child, i = null; null !== n;) {
            null !== (e = n.alternate) && null === sn(e) && (i = n), n = n.sibling;
          }

          null === (n = i) ? (i = t.child, t.child = null) : (i = n.sibling, n.sibling = null), Tr(t, !1, i, n, l, t.lastEffect);
          break;

        case "backwards":
          for (n = null, i = t.child, t.child = null; null !== i;) {
            if (null !== (e = i.alternate) && null === sn(e)) {
              t.child = i;
              break;
            }

            e = i.sibling, i.sibling = n, n = i, i = e;
          }

          Tr(t, !0, n, null, l, t.lastEffect);
          break;

        case "together":
          Tr(t, !1, null, null, void 0, t.lastEffect);
          break;

        default:
          t.memoizedState = null;
      }
      return t.child;
    }

    function Pr(e, t, n) {
      null !== e && (t.dependencies = e.dependencies);
      var r = t.expirationTime;
      if (0 !== r && Xi(r), t.childExpirationTime < n) return null;
      if (null !== e && t.child !== e.child) throw Error(a(153));

      if (null !== t.child) {
        for (n = sl(e = t.child, e.pendingProps), t.child = n, n.return = t; null !== e.sibling;) {
          e = e.sibling, (n = n.sibling = sl(e, e.pendingProps)).return = t;
        }

        n.sibling = null;
      }

      return t.child;
    }

    function Er(e) {
      e.effectTag |= 4;
    }

    if (q) _pr = function pr(e, t) {
      for (var n = t.child; null !== n;) {
        if (5 === n.tag || 6 === n.tag) D(e, n.stateNode);else if (4 !== n.tag && null !== n.child) {
          n.child.return = n, n = n.child;
          continue;
        }
        if (n === t) break;

        for (; null === n.sibling;) {
          if (null === n.return || n.return === t) return;
          n = n.return;
        }

        n.sibling.return = n.return, n = n.sibling;
      }
    }, mr = function mr() {}, hr = function hr(e, t, n, r, i) {
      if ((e = e.memoizedProps) !== r) {
        var l = t.stateNode,
            a = rn(en.current);
        n = U(l, n, e, r, i, a), (t.updateQueue = n) && Er(t);
      }
    }, gr = function gr(e, t, n, r) {
      n !== r && Er(t);
    };else if ($) {
      _pr = function pr(e, t, n, r) {
        for (var i = t.child; null !== i;) {
          if (5 === i.tag) {
            var l = i.stateNode;
            n && r && (l = me(l, i.type, i.memoizedProps, i)), D(e, l);
          } else if (6 === i.tag) l = i.stateNode, n && r && (l = he(l, i.memoizedProps, i)), D(e, l);else if (4 !== i.tag) {
            if (13 === i.tag && 0 != (4 & i.effectTag) && (l = null !== i.memoizedState)) {
              var a = i.child;

              if (null !== a && (null !== a.child && (a.child.return = a, _pr(e, a, !0, l)), null !== (l = a.sibling))) {
                l.return = i, i = l;
                continue;
              }
            }

            if (null !== i.child) {
              i.child.return = i, i = i.child;
              continue;
            }
          }

          if (i === t) break;

          for (; null === i.sibling;) {
            if (null === i.return || i.return === t) return;
            i = i.return;
          }

          i.sibling.return = i.return, i = i.sibling;
        }
      };

      var Sr = function Sr(e, t, n, r) {
        for (var i = t.child; null !== i;) {
          if (5 === i.tag) {
            var l = i.stateNode;
            n && r && (l = me(l, i.type, i.memoizedProps, i)), fe(e, l);
          } else if (6 === i.tag) l = i.stateNode, n && r && (l = he(l, i.memoizedProps, i)), fe(e, l);else if (4 !== i.tag) {
            if (13 === i.tag && 0 != (4 & i.effectTag) && (l = null !== i.memoizedState)) {
              var a = i.child;

              if (null !== a && (null !== a.child && (a.child.return = a, Sr(e, a, !0, l)), null !== (l = a.sibling))) {
                l.return = i, i = l;
                continue;
              }
            }

            if (null !== i.child) {
              i.child.return = i, i = i.child;
              continue;
            }
          }

          if (i === t) break;

          for (; null === i.sibling;) {
            if (null === i.return || i.return === t) return;
            i = i.return;
          }

          i.sibling.return = i.return, i = i.sibling;
        }
      };

      mr = function mr(e) {
        var t = e.stateNode;

        if (null !== e.firstEffect) {
          var n = t.containerInfo,
              r = se(n);
          Sr(r, e, !1, !1), t.pendingChildren = r, Er(e), de(n, r);
        }
      }, hr = function hr(e, t, n, r, i) {
        var l = e.stateNode,
            a = e.memoizedProps;
        if ((e = null === t.firstEffect) && a === r) t.stateNode = l;else {
          var o = t.stateNode,
              u = rn(en.current),
              c = null;
          a !== r && (c = U(o, n, a, r, i, u)), e && null === c ? t.stateNode = l : (l = ce(l, c, n, a, r, t, e, o), F(l, n, r, i, u) && Er(t), t.stateNode = l, e ? Er(t) : _pr(l, t, !1, !1));
        }
      }, gr = function gr(e, t, n, r) {
        n !== r ? (e = rn(nn.current), n = rn(en.current), t.stateNode = L(r, e, n, t), Er(t)) : t.stateNode = e.stateNode;
      };
    } else mr = function mr() {}, hr = function hr() {}, gr = function gr() {};

    function wr(e, t) {
      switch (e.tailMode) {
        case "hidden":
          t = e.tail;

          for (var n = null; null !== t;) {
            null !== t.alternate && (n = t), t = t.sibling;
          }

          null === n ? e.tail = null : n.sibling = null;
          break;

        case "collapsed":
          n = e.tail;

          for (var r = null; null !== n;) {
            null !== n.alternate && (r = n), n = n.sibling;
          }

          null === r ? t || null === e.tail ? e.tail = null : e.tail.sibling = null : r.sibling = null;
      }
    }

    function Cr(e, t, n) {
      var r = t.pendingProps;

      switch (t.tag) {
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
          return null;

        case 1:
          return Ue(t.type) && Me(), null;

        case 3:
          return an(), Ne(je), Ne(Oe), (r = t.stateNode).pendingContext && (r.context = r.pendingContext, r.pendingContext = null), (null === e || null === e.child) && er(t) && Er(t), mr(t), null;

        case 5:
          un(t);
          var i = rn(nn.current);
          if (n = t.type, null !== e && null != t.stateNode) hr(e, t, n, r, i), e.ref !== t.ref && (t.effectTag |= 128);else {
            if (!r) {
              if (null === t.stateNode) throw Error(a(166));
              return null;
            }

            if (e = rn(en.current), er(t)) {
              if (!V) throw Error(a(175));
              e = Pe(t.stateNode, t.type, t.memoizedProps, i, e, t), t.updateQueue = e, null !== e && Er(t);
            } else {
              var l = j(n, r, i, e, t);
              _pr(l, t, !1, !1), t.stateNode = l, F(l, n, r, i, e) && Er(t);
            }

            null !== t.ref && (t.effectTag |= 128);
          }
          return null;

        case 6:
          if (e && null != t.stateNode) gr(e, t, e.memoizedProps, r);else {
            if ("string" != typeof r && null === t.stateNode) throw Error(a(166));

            if (e = rn(nn.current), i = rn(en.current), er(t)) {
              if (!V) throw Error(a(176));
              Ee(t.stateNode, t.memoizedProps, t) && Er(t);
            } else t.stateNode = L(r, e, i, t);
          }
          return null;

        case 13:
          return Ne(cn), r = t.memoizedState, 0 != (64 & t.effectTag) ? (t.expirationTime = n, t) : (r = null !== r, i = !1, null === e ? void 0 !== t.memoizedProps.fallback && er(t) : (i = null !== (n = e.memoizedState), r || null === n || null !== (n = e.child.sibling) && (null !== (l = t.firstEffect) ? (t.firstEffect = n, n.nextEffect = l) : (t.firstEffect = t.lastEffect = n, n.nextEffect = null), n.effectTag = 8)), r && !i && 0 != (2 & t.mode) && (null === e && !0 !== t.memoizedProps.unstable_avoidThisFallback || 0 != (1 & cn.current) ? di === ni && (di = li) : (di !== ni && di !== li || (di = ai), 0 !== yi && null !== ci && (yl(ci, fi), vl(ci, yi)))), $ && r && (t.effectTag |= 4), q && (r || i) && (t.effectTag |= 4), null);

        case 4:
          return an(), mr(t), null;

        case 10:
          return _t(t), null;

        case 17:
          return Ue(t.type) && Me(), null;

        case 19:
          if (Ne(cn), null === (r = t.memoizedState)) return null;

          if (i = 0 != (64 & t.effectTag), null === (l = r.rendering)) {
            if (i) wr(r, !1);else if (di !== ni || null !== e && 0 != (64 & e.effectTag)) for (e = t.child; null !== e;) {
              if (null !== (l = sn(e))) {
                for (t.effectTag |= 64, wr(r, !1), null !== (e = l.updateQueue) && (t.updateQueue = e, t.effectTag |= 4), null === r.lastEffect && (t.firstEffect = null), t.lastEffect = r.lastEffect, e = n, r = t.child; null !== r;) {
                  n = e, (i = r).effectTag &= 2, i.nextEffect = null, i.firstEffect = null, i.lastEffect = null, null === (l = i.alternate) ? (i.childExpirationTime = 0, i.expirationTime = n, i.child = null, i.memoizedProps = null, i.memoizedState = null, i.updateQueue = null, i.dependencies = null) : (i.childExpirationTime = l.childExpirationTime, i.expirationTime = l.expirationTime, i.child = l.child, i.memoizedProps = l.memoizedProps, i.memoizedState = l.memoizedState, i.updateQueue = l.updateQueue, n = l.dependencies, i.dependencies = null === n ? null : {
                    expirationTime: n.expirationTime,
                    firstContext: n.firstContext,
                    responders: n.responders
                  }), r = r.sibling;
                }

                return ze(cn, 1 & cn.current | 2), t.child;
              }

              e = e.sibling;
            }
          } else {
            if (!i) if (null !== (e = sn(l))) {
              if (t.effectTag |= 64, i = !0, null !== (e = e.updateQueue) && (t.updateQueue = e, t.effectTag |= 4), wr(r, !0), null === r.tail && "hidden" === r.tailMode && !l.alternate) return null !== (t = t.lastEffect = r.lastEffect) && (t.nextEffect = null), null;
            } else 2 * ut() - r.renderingStartTime > r.tailExpiration && 1 < n && (t.effectTag |= 64, i = !0, wr(r, !1), t.expirationTime = t.childExpirationTime = n - 1);
            r.isBackwards ? (l.sibling = t.child, t.child = l) : (null !== (e = r.last) ? e.sibling = l : t.child = l, r.last = l);
          }

          return null !== r.tail ? (0 === r.tailExpiration && (r.tailExpiration = ut() + 500), e = r.tail, r.rendering = e, r.tail = e.sibling, r.lastEffect = t.lastEffect, r.renderingStartTime = ut(), e.sibling = null, t = cn.current, ze(cn, i ? 1 & t | 2 : 1 & t), e) : null;
      }

      throw Error(a(156, t.tag));
    }

    function _r(e) {
      switch (e.tag) {
        case 1:
          Ue(e.type) && Me();
          var t = e.effectTag;
          return 4096 & t ? (e.effectTag = -4097 & t | 64, e) : null;

        case 3:
          if (an(), Ne(je), Ne(Oe), 0 != (64 & (t = e.effectTag))) throw Error(a(285));
          return e.effectTag = -4097 & t | 64, e;

        case 5:
          return un(e), null;

        case 13:
          return Ne(cn), 4096 & (t = e.effectTag) ? (e.effectTag = -4097 & t | 64, e) : null;

        case 19:
          return Ne(cn), null;

        case 4:
          return an(), null;

        case 10:
          return _t(e), null;

        default:
          return null;
      }
    }

    function kr(e, t) {
      return {
        value: e,
        source: t,
        stack: ke(t)
      };
    }

    var Ir = "function" == typeof WeakSet ? WeakSet : Set;

    function Rr(e, t) {
      var n = t.source,
          r = t.stack;
      null === r && null !== n && (r = ke(n)), null !== n && w(n.type), t = t.value, null !== e && 1 === e.tag && w(e.type);

      try {
        console.error(t);
      } catch (e) {
        setTimeout(function () {
          throw e;
        });
      }
    }

    function Nr(e) {
      var t = e.ref;
      if (null !== t) if ("function" == typeof t) try {
        t(null);
      } catch (t) {
        nl(e, t);
      } else t.current = null;
    }

    function zr(e, t) {
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
        case 22:
          return;

        case 1:
          if (256 & t.effectTag && null !== e) {
            var n = e.memoizedProps,
                r = e.memoizedState;
            t = (e = t.stateNode).getSnapshotBeforeUpdate(t.elementType === t.type ? n : Tt(t.type, n), r), e.__reactInternalSnapshotBeforeUpdate = t;
          }

          return;

        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
          return;
      }

      throw Error(a(163));
    }

    function Ar(e, t) {
      if (null !== (t = null !== (t = t.updateQueue) ? t.lastEffect : null)) {
        var n = t = t.next;

        do {
          if ((n.tag & e) === e) {
            var r = n.destroy;
            n.destroy = void 0, void 0 !== r && r();
          }

          n = n.next;
        } while (n !== t);
      }
    }

    function Or(e, t) {
      if (null !== (t = null !== (t = t.updateQueue) ? t.lastEffect : null)) {
        var n = t = t.next;

        do {
          if ((n.tag & e) === e) {
            var r = n.create;
            n.destroy = r();
          }

          n = n.next;
        } while (n !== t);
      }
    }

    function jr(e, t, n) {
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
        case 22:
          return void Or(3, n);

        case 1:
          if (e = n.stateNode, 4 & n.effectTag) if (null === t) e.componentDidMount();else {
            var r = n.elementType === n.type ? t.memoizedProps : Tt(n.type, t.memoizedProps);
            e.componentDidUpdate(r, t.memoizedState, e.__reactInternalSnapshotBeforeUpdate);
          }
          return void (null !== (t = n.updateQueue) && Ut(n, t, e));

        case 3:
          if (null !== (t = n.updateQueue)) {
            if (e = null, null !== n.child) switch (n.child.tag) {
              case 5:
                e = R(n.child.stateNode);
                break;

              case 1:
                e = n.child.stateNode;
            }
            Ut(n, t, e);
          }

          return;

        case 5:
          return e = n.stateNode, void (null === t && 4 & n.effectTag && J(e, n.type, n.memoizedProps, n));

        case 6:
        case 4:
        case 12:
          return;

        case 13:
          return void (V && null === n.memoizedState && (n = n.alternate, null !== n && (n = n.memoizedState, null !== n && (n = n.dehydrated, null !== n && Ce(n)))));

        case 19:
        case 17:
        case 20:
        case 21:
          return;
      }

      throw Error(a(163));
    }

    function Dr(e, t, n) {
      switch ("function" == typeof al && al(t), t.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
          if (null !== (e = t.updateQueue) && null !== (e = e.lastEffect)) {
            var r = e.next;
            ft(97 < n ? 97 : n, function () {
              var e = r;

              do {
                var n = e.destroy;

                if (void 0 !== n) {
                  var i = t;

                  try {
                    n();
                  } catch (e) {
                    nl(i, e);
                  }
                }

                e = e.next;
              } while (e !== r);
            });
          }

          break;

        case 1:
          Nr(t), "function" == typeof (n = t.stateNode).componentWillUnmount && function (e, t) {
            try {
              t.props = e.memoizedProps, t.state = e.memoizedState, t.componentWillUnmount();
            } catch (t) {
              nl(e, t);
            }
          }(t, n);
          break;

        case 5:
          Nr(t);
          break;

        case 4:
          q ? Lr(e, t, n) : $ && function (e) {
            if ($) {
              e = e.stateNode.containerInfo;
              var t = se(e);
              pe(e, t);
            }
          }(t);
      }
    }

    function Fr(e, t, n) {
      for (var r = t;;) {
        if (Dr(e, r, n), null === r.child || q && 4 === r.tag) {
          if (r === t) break;

          for (; null === r.sibling;) {
            if (null === r.return || r.return === t) return;
            r = r.return;
          }

          r.sibling.return = r.return, r = r.sibling;
        } else r.child.return = r, r = r.child;
      }
    }

    function Ur(e) {
      var t = e.alternate;
      e.return = null, e.child = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.alternate = null, e.firstEffect = null, e.lastEffect = null, e.pendingProps = null, e.memoizedProps = null, e.stateNode = null, null !== t && Ur(t);
    }

    function Mr(e) {
      return 5 === e.tag || 3 === e.tag || 4 === e.tag;
    }

    function Qr(e) {
      if (q) {
        e: {
          for (var t = e.return; null !== t;) {
            if (Mr(t)) {
              var n = t;
              break e;
            }

            t = t.return;
          }

          throw Error(a(160));
        }

        switch (t = n.stateNode, n.tag) {
          case 5:
            var r = !1;
            break;

          case 3:
          case 4:
            t = t.containerInfo, r = !0;
            break;

          default:
            throw Error(a(161));
        }

        16 & n.effectTag && (ie(t), n.effectTag &= -17);

        e: t: for (n = e;;) {
          for (; null === n.sibling;) {
            if (null === n.return || Mr(n.return)) {
              n = null;
              break e;
            }

            n = n.return;
          }

          for (n.sibling.return = n.return, n = n.sibling; 5 !== n.tag && 6 !== n.tag && 18 !== n.tag;) {
            if (2 & n.effectTag) continue t;
            if (null === n.child || 4 === n.tag) continue t;
            n.child.return = n, n = n.child;
          }

          if (!(2 & n.effectTag)) {
            n = n.stateNode;
            break e;
          }
        }

        r ? function e(t, n, r) {
          var i = t.tag,
              l = 5 === i || 6 === i;
          if (l) t = l ? t.stateNode : t.stateNode.instance, n ? te(r, t, n) : K(r, t);else if (4 !== i && (t = t.child, null !== t)) for (e(t, n, r), t = t.sibling; null !== t;) {
            e(t, n, r), t = t.sibling;
          }
        }(e, n, t) : function e(t, n, r) {
          var i = t.tag,
              l = 5 === i || 6 === i;
          if (l) t = l ? t.stateNode : t.stateNode.instance, n ? ee(r, t, n) : Y(r, t);else if (4 !== i && (t = t.child, null !== t)) for (e(t, n, r), t = t.sibling; null !== t;) {
            e(t, n, r), t = t.sibling;
          }
        }(e, n, t);
      }
    }

    function Lr(e, t, n) {
      for (var r, i, l = t, o = !1;;) {
        if (!o) {
          o = l.return;

          e: for (;;) {
            if (null === o) throw Error(a(160));

            switch (r = o.stateNode, o.tag) {
              case 5:
                i = !1;
                break e;

              case 3:
              case 4:
                r = r.containerInfo, i = !0;
                break e;
            }

            o = o.return;
          }

          o = !0;
        }

        if (5 === l.tag || 6 === l.tag) Fr(e, l, n), i ? re(r, l.stateNode) : ne(r, l.stateNode);else if (4 === l.tag) {
          if (null !== l.child) {
            r = l.stateNode.containerInfo, i = !0, l.child.return = l, l = l.child;
            continue;
          }
        } else if (Dr(e, l, n), null !== l.child) {
          l.child.return = l, l = l.child;
          continue;
        }
        if (l === t) break;

        for (; null === l.sibling;) {
          if (null === l.return || l.return === t) return;
          4 === (l = l.return).tag && (o = !1);
        }

        l.sibling.return = l.return, l = l.sibling;
      }
    }

    function Hr(e, t) {
      if (q) {
        switch (t.tag) {
          case 0:
          case 11:
          case 14:
          case 15:
          case 22:
            return void Ar(3, t);

          case 1:
            return;

          case 5:
            var n = t.stateNode;

            if (null != n) {
              var r = t.memoizedProps;
              e = null !== e ? e.memoizedProps : r;
              var i = t.type,
                  l = t.updateQueue;
              t.updateQueue = null, null !== l && Z(n, l, i, e, r, t);
            }

            return;

          case 6:
            if (null === t.stateNode) throw Error(a(162));
            return n = t.memoizedProps, void G(t.stateNode, null !== e ? e.memoizedProps : n, n);

          case 3:
            return void (V && (t = t.stateNode, t.hydrate && (t.hydrate = !1, we(t.containerInfo))));

          case 12:
            return;

          case 13:
            return Wr(t), void Br(t);

          case 19:
            return void Br(t);

          case 17:
            return;
        }

        throw Error(a(163));
      }

      switch (t.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
          return void Ar(3, t);

        case 12:
          return;

        case 13:
          return Wr(t), void Br(t);

        case 19:
          return void Br(t);

        case 3:
          V && (n = t.stateNode).hydrate && (n.hydrate = !1, we(n.containerInfo));
      }

      e: if ($) {
        switch (t.tag) {
          case 1:
          case 5:
          case 6:
          case 20:
            break e;

          case 3:
          case 4:
            t = t.stateNode, pe(t.containerInfo, t.pendingChildren);
            break e;
        }

        throw Error(a(163));
      }
    }

    function Wr(e) {
      var t = e;
      if (null === e.memoizedState) var n = !1;else n = !0, t = e.child, bi = ut();
      if (q && null !== t) e: if (e = t, q) for (t = e;;) {
        if (5 === t.tag) {
          var r = t.stateNode;
          n ? le(r) : oe(t.stateNode, t.memoizedProps);
        } else if (6 === t.tag) r = t.stateNode, n ? ae(r) : ue(r, t.memoizedProps);else {
          if (13 === t.tag && null !== t.memoizedState && null === t.memoizedState.dehydrated) {
            (r = t.child.sibling).return = t, t = r;
            continue;
          }

          if (null !== t.child) {
            t.child.return = t, t = t.child;
            continue;
          }
        }

        if (t === e) break e;

        for (; null === t.sibling;) {
          if (null === t.return || t.return === e) break e;
          t = t.return;
        }

        t.sibling.return = t.return, t = t.sibling;
      }
    }

    function Br(e) {
      var t = e.updateQueue;

      if (null !== t) {
        e.updateQueue = null;
        var n = e.stateNode;
        null === n && (n = e.stateNode = new Ir()), t.forEach(function (t) {
          var r = function (e, t) {
            var n = e.stateNode;
            null !== n && n.delete(t), 0 == (t = 0) && (t = Ai(t = zi(), e, null)), null !== (e = ji(e, t)) && Fi(e);
          }.bind(null, e, t);

          n.has(t) || (n.add(t), t.then(r, r));
        });
      }
    }

    var Xr = "function" == typeof WeakMap ? WeakMap : Map;

    function qr(e, t, n) {
      (n = Ot(n, null)).tag = 3, n.payload = {
        element: null
      };
      var r = t.value;
      return n.callback = function () {
        Pi || (Pi = !0, Ei = r), Rr(e, t);
      }, n;
    }

    function $r(e, t, n) {
      (n = Ot(n, null)).tag = 3;
      var r = e.type.getDerivedStateFromError;

      if ("function" == typeof r) {
        var i = t.value;

        n.payload = function () {
          return Rr(e, t), r(i);
        };
      }

      var l = e.stateNode;
      return null !== l && "function" == typeof l.componentDidCatch && (n.callback = function () {
        "function" != typeof r && (null === Si ? Si = new Set([this]) : Si.add(this), Rr(e, t));
        var n = t.stack;
        this.componentDidCatch(t.value, {
          componentStack: null !== n ? n : ""
        });
      }), n;
    }

    var Vr,
        Yr = Math.ceil,
        Kr = o.ReactCurrentDispatcher,
        Gr = o.ReactCurrentOwner,
        Jr = 0,
        Zr = 8,
        ei = 16,
        ti = 32,
        ni = 0,
        ri = 1,
        ii = 2,
        li = 3,
        ai = 4,
        oi = 5,
        ui = Jr,
        ci = null,
        si = null,
        fi = 0,
        di = ni,
        pi = null,
        mi = 1073741823,
        hi = 1073741823,
        gi = null,
        yi = 0,
        vi = !1,
        bi = 0,
        Ti = 500,
        xi = null,
        Pi = !1,
        Ei = null,
        Si = null,
        wi = !1,
        Ci = null,
        _i = 90,
        ki = null,
        Ii = 0,
        Ri = null,
        Ni = 0;

    function zi() {
      return (ui & (ei | ti)) !== Jr ? 1073741821 - (ut() / 10 | 0) : 0 !== Ni ? Ni : Ni = 1073741821 - (ut() / 10 | 0);
    }

    function Ai(e, t, n) {
      if (0 == (2 & (t = t.mode))) return 1073741823;
      var r = ct();
      if (0 == (4 & t)) return 99 === r ? 1073741823 : 1073741822;
      if ((ui & ei) !== Jr) return fi;
      if (null !== n) e = gt(e, 0 | n.timeoutMs || 5e3, 250);else switch (r) {
        case 99:
          e = 1073741823;
          break;

        case 98:
          e = gt(e, 150, 100);
          break;

        case 97:
        case 96:
          e = gt(e, 5e3, 250);
          break;

        case 95:
          e = 2;
          break;

        default:
          throw Error(a(326));
      }
      return null !== ci && e === fi && --e, e;
    }

    function Oi(e, t) {
      if (50 < Ii) throw Ii = 0, Ri = null, Error(a(185));

      if (null !== (e = ji(e, t))) {
        var n = ct();
        1073741823 === t ? (ui & Zr) !== Jr && (ui & (ei | ti)) === Jr ? Ui(e) : (Fi(e), ui === Jr && mt()) : Fi(e), (4 & ui) === Jr || 98 !== n && 99 !== n || (null === ki ? ki = new Map([[e, t]]) : (void 0 === (n = ki.get(e)) || n > t) && ki.set(e, t));
      }
    }

    function ji(e, t) {
      e.expirationTime < t && (e.expirationTime = t);
      var n = e.alternate;
      null !== n && n.expirationTime < t && (n.expirationTime = t);
      var r = e.return,
          i = null;
      if (null === r && 3 === e.tag) i = e.stateNode;else for (; null !== r;) {
        if (n = r.alternate, r.childExpirationTime < t && (r.childExpirationTime = t), null !== n && n.childExpirationTime < t && (n.childExpirationTime = t), null === r.return && 3 === r.tag) {
          i = r.stateNode;
          break;
        }

        r = r.return;
      }
      return null !== i && (ci === i && (Xi(t), di === ai && yl(i, fi)), vl(i, t)), i;
    }

    function Di(e) {
      var t = e.lastExpiredTime;
      if (0 !== t) return t;
      if (!gl(e, t = e.firstPendingTime)) return t;
      var n = e.lastPingedTime;
      return 2 >= (e = n > (e = e.nextKnownPendingLevel) ? n : e) && t !== e ? 0 : e;
    }

    function Fi(e) {
      if (0 !== e.lastExpiredTime) e.callbackExpirationTime = 1073741823, e.callbackPriority = 99, e.callbackNode = pt(Ui.bind(null, e));else {
        var t = Di(e),
            n = e.callbackNode;
        if (0 === t) null !== n && (e.callbackNode = null, e.callbackExpirationTime = 0, e.callbackPriority = 90);else {
          var r = zi();

          if (1073741823 === t ? r = 99 : 1 === t || 2 === t ? r = 95 : r = 0 >= (r = 10 * (1073741821 - t) - 10 * (1073741821 - r)) ? 99 : 250 >= r ? 98 : 5250 >= r ? 97 : 95, null !== n) {
            var i = e.callbackPriority;
            if (e.callbackExpirationTime === t && i >= r) return;
            n !== tt && qe(n);
          }

          e.callbackExpirationTime = t, e.callbackPriority = r, t = 1073741823 === t ? pt(Ui.bind(null, e)) : dt(r, function e(t, n) {
            Ni = 0;
            if (n) return n = zi(), bl(t, n), Fi(t), null;
            var r = Di(t);

            if (0 !== r) {
              if (n = t.callbackNode, (ui & (ei | ti)) !== Jr) throw Error(a(327));

              if (Zi(), t === ci && r === fi || Li(t, r), null !== si) {
                var i = ui;
                ui |= ei;

                for (var l = Wi();;) {
                  try {
                    $i();
                    break;
                  } catch (e) {
                    Hi(t, e);
                  }
                }

                if (wt(), ui = i, Kr.current = l, di === ri) throw n = pi, Li(t, r), yl(t, r), Fi(t), n;
                if (null === si) switch (l = t.finishedWork = t.current.alternate, t.finishedExpirationTime = r, i = di, ci = null, i) {
                  case ni:
                  case ri:
                    throw Error(a(345));

                  case ii:
                    bl(t, 2 < r ? 2 : r);
                    break;

                  case li:
                    if (yl(t, r), i = t.lastSuspendedTime, r === i && (t.nextKnownPendingLevel = Ki(l)), 1073741823 === mi && 10 < (l = bi + Ti - ut())) {
                      if (vi) {
                        var o = t.lastPingedTime;

                        if (0 === o || o >= r) {
                          t.lastPingedTime = r, Li(t, r);
                          break;
                        }
                      }

                      if (0 !== (o = Di(t)) && o !== r) break;

                      if (0 !== i && i !== r) {
                        t.lastPingedTime = i;
                        break;
                      }

                      t.timeoutHandle = H(Gi.bind(null, t), l);
                      break;
                    }

                    Gi(t);
                    break;

                  case ai:
                    if (yl(t, r), i = t.lastSuspendedTime, r === i && (t.nextKnownPendingLevel = Ki(l)), vi && (0 === (l = t.lastPingedTime) || l >= r)) {
                      t.lastPingedTime = r, Li(t, r);
                      break;
                    }

                    if (0 !== (l = Di(t)) && l !== r) break;

                    if (0 !== i && i !== r) {
                      t.lastPingedTime = i;
                      break;
                    }

                    if (1073741823 !== hi ? i = 10 * (1073741821 - hi) - ut() : 1073741823 === mi ? i = 0 : (i = 10 * (1073741821 - mi) - 5e3, l = ut(), r = 10 * (1073741821 - r) - l, 0 > (i = l - i) && (i = 0), i = (120 > i ? 120 : 480 > i ? 480 : 1080 > i ? 1080 : 1920 > i ? 1920 : 3e3 > i ? 3e3 : 4320 > i ? 4320 : 1960 * Yr(i / 1960)) - i, r < i && (i = r)), 10 < i) {
                      t.timeoutHandle = H(Gi.bind(null, t), i);
                      break;
                    }

                    Gi(t);
                    break;

                  case oi:
                    if (1073741823 !== mi && null !== gi) {
                      o = mi;
                      var u = gi;

                      if (0 >= (i = 0 | u.busyMinDurationMs) ? i = 0 : (l = 0 | u.busyDelayMs, o = ut() - (10 * (1073741821 - o) - (0 | u.timeoutMs || 5e3)), i = o <= l ? 0 : l + i - o), 10 < i) {
                        yl(t, r), t.timeoutHandle = H(Gi.bind(null, t), i);
                        break;
                      }
                    }

                    Gi(t);
                    break;

                  default:
                    throw Error(a(329));
                }
                if (Fi(t), t.callbackNode === n) return e.bind(null, t);
              }
            }

            return null;
          }.bind(null, e), {
            timeout: 10 * (1073741821 - t) - ut()
          }), e.callbackNode = t;
        }
      }
    }

    function Ui(e) {
      var t = e.lastExpiredTime;
      if (t = 0 !== t ? t : 1073741823, (ui & (ei | ti)) !== Jr) throw Error(a(327));

      if (Zi(), e === ci && t === fi || Li(e, t), null !== si) {
        var n = ui;
        ui |= ei;

        for (var r = Wi();;) {
          try {
            qi();
            break;
          } catch (t) {
            Hi(e, t);
          }
        }

        if (wt(), ui = n, Kr.current = r, di === ri) throw n = pi, Li(e, t), yl(e, t), Fi(e), n;
        if (null !== si) throw Error(a(261));
        e.finishedWork = e.current.alternate, e.finishedExpirationTime = t, ci = null, Gi(e), Fi(e);
      }

      return null;
    }

    function Mi(e, t) {
      var n = ui;
      ui |= 1;

      try {
        return e(t);
      } finally {
        (ui = n) === Jr && mt();
      }
    }

    function Qi(e, t) {
      if ((ui & (ei | ti)) !== Jr) throw Error(a(187));
      var n = ui;
      ui |= 1;

      try {
        return ft(99, e.bind(null, t));
      } finally {
        ui = n, mt();
      }
    }

    function Li(e, t) {
      e.finishedWork = null, e.finishedExpirationTime = 0;
      var n = e.timeoutHandle;
      if (n !== B && (e.timeoutHandle = B, W(n)), null !== si) for (n = si.return; null !== n;) {
        var r = n;

        switch (r.tag) {
          case 1:
            null != (r = r.type.childContextTypes) && Me();
            break;

          case 3:
            an(), Ne(je), Ne(Oe);
            break;

          case 5:
            un(r);
            break;

          case 4:
            an();
            break;

          case 13:
          case 19:
            Ne(cn);
            break;

          case 10:
            _t(r);

        }

        n = n.return;
      }
      ci = e, si = sl(e.current, null), fi = t, di = ni, pi = null, hi = mi = 1073741823, gi = null, yi = 0, vi = !1;
    }

    function Hi(e, t) {
      for (;;) {
        try {
          if (wt(), dn.current = Wn, vn) for (var n = hn.memoizedState; null !== n;) {
            var r = n.queue;
            null !== r && (r.pending = null), n = n.next;
          }
          if (mn = 0, yn = gn = hn = null, vn = !1, null === si || null === si.return) return di = ri, pi = t, si = null;

          e: {
            var i = e,
                l = si.return,
                a = si,
                o = t;

            if (t = fi, a.effectTag |= 2048, a.firstEffect = a.lastEffect = null, null !== o && "object" == typeof o && "function" == typeof o.then) {
              var u = o;

              if (0 == (2 & a.mode)) {
                var c = a.alternate;
                c ? (a.updateQueue = c.updateQueue, a.memoizedState = c.memoizedState, a.expirationTime = c.expirationTime) : (a.updateQueue = null, a.memoizedState = null);
              }

              var s = 0 != (1 & cn.current),
                  f = l;

              do {
                var d;

                if (d = 13 === f.tag) {
                  var p = f.memoizedState;
                  if (null !== p) d = null !== p.dehydrated;else {
                    var m = f.memoizedProps;
                    d = void 0 !== m.fallback && (!0 !== m.unstable_avoidThisFallback || !s);
                  }
                }

                if (d) {
                  var h = f.updateQueue;

                  if (null === h) {
                    var g = new Set();
                    g.add(u), f.updateQueue = g;
                  } else h.add(u);

                  if (0 == (2 & f.mode)) {
                    if (f.effectTag |= 64, a.effectTag &= -2981, 1 === a.tag) if (null === a.alternate) a.tag = 17;else {
                      var y = Ot(1073741823, null);
                      y.tag = 2, jt(a, y);
                    }
                    a.expirationTime = 1073741823;
                    break e;
                  }

                  o = void 0, a = t;
                  var v = i.pingCache;

                  if (null === v ? (v = i.pingCache = new Xr(), o = new Set(), v.set(u, o)) : void 0 === (o = v.get(u)) && (o = new Set(), v.set(u, o)), !o.has(a)) {
                    o.add(a);
                    var b = rl.bind(null, i, u, a);
                    u.then(b, b);
                  }

                  f.effectTag |= 4096, f.expirationTime = t;
                  break e;
                }

                f = f.return;
              } while (null !== f);

              o = Error((w(a.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + ke(a));
            }

            di !== oi && (di = ii), o = kr(o, a), f = l;

            do {
              switch (f.tag) {
                case 3:
                  u = o, f.effectTag |= 4096, f.expirationTime = t, Dt(f, qr(f, u, t));
                  break e;

                case 1:
                  u = o;
                  var T = f.type,
                      x = f.stateNode;

                  if (0 == (64 & f.effectTag) && ("function" == typeof T.getDerivedStateFromError || null !== x && "function" == typeof x.componentDidCatch && (null === Si || !Si.has(x)))) {
                    f.effectTag |= 4096, f.expirationTime = t, Dt(f, $r(f, u, t));
                    break e;
                  }

              }

              f = f.return;
            } while (null !== f);
          }

          si = Yi(si);
        } catch (e) {
          t = e;
          continue;
        }

        break;
      }
    }

    function Wi() {
      var e = Kr.current;
      return Kr.current = Wn, null === e ? Wn : e;
    }

    function Bi(e, t) {
      e < mi && 2 < e && (mi = e), null !== t && e < hi && 2 < e && (hi = e, gi = t);
    }

    function Xi(e) {
      e > yi && (yi = e);
    }

    function qi() {
      for (; null !== si;) {
        si = Vi(si);
      }
    }

    function $i() {
      for (; null !== si && !nt();) {
        si = Vi(si);
      }
    }

    function Vi(e) {
      var t = Vr(e.alternate, e, fi);
      return e.memoizedProps = e.pendingProps, null === t && (t = Yi(e)), Gr.current = null, t;
    }

    function Yi(e) {
      si = e;

      do {
        var t = si.alternate;

        if (e = si.return, 0 == (2048 & si.effectTag)) {
          if (t = Cr(t, si, fi), 1 === fi || 1 !== si.childExpirationTime) {
            for (var n = 0, r = si.child; null !== r;) {
              var i = r.expirationTime,
                  l = r.childExpirationTime;
              i > n && (n = i), l > n && (n = l), r = r.sibling;
            }

            si.childExpirationTime = n;
          }

          if (null !== t) return t;
          null !== e && 0 == (2048 & e.effectTag) && (null === e.firstEffect && (e.firstEffect = si.firstEffect), null !== si.lastEffect && (null !== e.lastEffect && (e.lastEffect.nextEffect = si.firstEffect), e.lastEffect = si.lastEffect), 1 < si.effectTag && (null !== e.lastEffect ? e.lastEffect.nextEffect = si : e.firstEffect = si, e.lastEffect = si));
        } else {
          if (null !== (t = _r(si))) return t.effectTag &= 2047, t;
          null !== e && (e.firstEffect = e.lastEffect = null, e.effectTag |= 2048);
        }

        if (null !== (t = si.sibling)) return t;
        si = e;
      } while (null !== si);

      return di === ni && (di = oi), null;
    }

    function Ki(e) {
      var t = e.expirationTime;
      return t > (e = e.childExpirationTime) ? t : e;
    }

    function Gi(e) {
      var t = ct();
      return ft(99, function (e, t) {
        do {
          Zi();
        } while (null !== Ci);

        if ((ui & (ei | ti)) !== Jr) throw Error(a(327));
        var n = e.finishedWork,
            r = e.finishedExpirationTime;
        if (null === n) return null;
        if (e.finishedWork = null, e.finishedExpirationTime = 0, n === e.current) throw Error(a(177));
        e.callbackNode = null, e.callbackExpirationTime = 0, e.callbackPriority = 90, e.nextKnownPendingLevel = 0;
        var i = Ki(n);

        if (e.firstPendingTime = i, r <= e.lastSuspendedTime ? e.firstSuspendedTime = e.lastSuspendedTime = e.nextKnownPendingLevel = 0 : r <= e.firstSuspendedTime && (e.firstSuspendedTime = r - 1), r <= e.lastPingedTime && (e.lastPingedTime = 0), r <= e.lastExpiredTime && (e.lastExpiredTime = 0), e === ci && (si = ci = null, fi = 0), 1 < n.effectTag ? null !== n.lastEffect ? (n.lastEffect.nextEffect = n, i = n.firstEffect) : i = n : i = n.firstEffect, null !== i) {
          var l = ui;
          ui |= ti, Gr.current = null, A(e.containerInfo), xi = i;

          do {
            try {
              Ji();
            } catch (e) {
              if (null === xi) throw Error(a(330));
              nl(xi, e), xi = xi.nextEffect;
            }
          } while (null !== xi);

          xi = i;

          do {
            try {
              for (var o = e, u = t; null !== xi;) {
                var c = xi.effectTag;

                if (16 & c && q && ie(xi.stateNode), 128 & c) {
                  var s = xi.alternate;

                  if (null !== s) {
                    var f = s.ref;
                    null !== f && ("function" == typeof f ? f(null) : f.current = null);
                  }
                }

                switch (1038 & c) {
                  case 2:
                    Qr(xi), xi.effectTag &= -3;
                    break;

                  case 6:
                    Qr(xi), xi.effectTag &= -3, Hr(xi.alternate, xi);
                    break;

                  case 1024:
                    xi.effectTag &= -1025;
                    break;

                  case 1028:
                    xi.effectTag &= -1025, Hr(xi.alternate, xi);
                    break;

                  case 4:
                    Hr(xi.alternate, xi);
                    break;

                  case 8:
                    var d = o,
                        p = xi,
                        m = u;
                    q ? Lr(d, p, m) : Fr(d, p, m), Ur(p);
                }

                xi = xi.nextEffect;
              }
            } catch (e) {
              if (null === xi) throw Error(a(330));
              nl(xi, e), xi = xi.nextEffect;
            }
          } while (null !== xi);

          O(e.containerInfo), e.current = n, xi = i;

          do {
            try {
              for (c = e; null !== xi;) {
                var h = xi.effectTag;

                if (36 & h && jr(c, xi.alternate, xi), 128 & h) {
                  s = void 0;
                  var g = xi.ref;

                  if (null !== g) {
                    var y = xi.stateNode;

                    switch (xi.tag) {
                      case 5:
                        s = R(y);
                        break;

                      default:
                        s = y;
                    }

                    "function" == typeof g ? g(s) : g.current = s;
                  }
                }

                xi = xi.nextEffect;
              }
            } catch (e) {
              if (null === xi) throw Error(a(330));
              nl(xi, e), xi = xi.nextEffect;
            }
          } while (null !== xi);

          xi = null, rt(), ui = l;
        } else e.current = n;

        if (wi) wi = !1, Ci = e, _i = t;else for (xi = i; null !== xi;) {
          t = xi.nextEffect, xi.nextEffect = null, xi = t;
        }
        if (0 === (t = e.firstPendingTime) && (Si = null), 1073741823 === t ? e === Ri ? Ii++ : (Ii = 0, Ri = e) : Ii = 0, "function" == typeof ll && ll(n.stateNode, r), Fi(e), Pi) throw Pi = !1, e = Ei, Ei = null, e;
        return (ui & Zr) !== Jr ? null : (mt(), null);
      }.bind(null, e, t)), null;
    }

    function Ji() {
      for (; null !== xi;) {
        var e = xi.effectTag;
        0 != (256 & e) && zr(xi.alternate, xi), 0 == (512 & e) || wi || (wi = !0, dt(97, function () {
          return Zi(), null;
        })), xi = xi.nextEffect;
      }
    }

    function Zi() {
      if (90 !== _i) {
        var e = 97 < _i ? 97 : _i;
        return _i = 90, ft(e, el);
      }
    }

    function el() {
      if (null === Ci) return !1;
      var e = Ci;
      if (Ci = null, (ui & (ei | ti)) !== Jr) throw Error(a(331));
      var t = ui;

      for (ui |= ti, e = e.current.firstEffect; null !== e;) {
        try {
          var n = e;
          if (0 != (512 & n.effectTag)) switch (n.tag) {
            case 0:
            case 11:
            case 15:
            case 22:
              Ar(5, n), Or(5, n);
          }
        } catch (t) {
          if (null === e) throw Error(a(330));
          nl(e, t);
        }

        n = e.nextEffect, e.nextEffect = null, e = n;
      }

      return ui = t, mt(), !0;
    }

    function tl(e, t, n) {
      jt(e, t = qr(e, t = kr(n, t), 1073741823)), null !== (e = ji(e, 1073741823)) && Fi(e);
    }

    function nl(e, t) {
      if (3 === e.tag) tl(e, e, t);else for (var n = e.return; null !== n;) {
        if (3 === n.tag) {
          tl(n, e, t);
          break;
        }

        if (1 === n.tag) {
          var r = n.stateNode;

          if ("function" == typeof n.type.getDerivedStateFromError || "function" == typeof r.componentDidCatch && (null === Si || !Si.has(r))) {
            jt(n, e = $r(n, e = kr(t, e), 1073741823)), null !== (n = ji(n, 1073741823)) && Fi(n);
            break;
          }
        }

        n = n.return;
      }
    }

    function rl(e, t, n) {
      var r = e.pingCache;
      null !== r && r.delete(t), ci === e && fi === n ? di === ai || di === li && 1073741823 === mi && ut() - bi < Ti ? Li(e, fi) : vi = !0 : gl(e, n) && (0 !== (t = e.lastPingedTime) && t < n || (e.lastPingedTime = n, Fi(e)));
    }

    Vr = function Vr(e, t, n) {
      var r = t.expirationTime;

      if (null !== e) {
        var i = t.pendingProps;
        if (e.memoizedProps !== i || je.current) rr = !0;else {
          if (r < n) {
            switch (rr = !1, t.tag) {
              case 3:
                dr(t), tr();
                break;

              case 5:
                if (on(t), 4 & t.mode && 1 !== n && Q(t.type, i)) return t.expirationTime = t.childExpirationTime = 1, null;
                break;

              case 1:
                Ue(t.type) && He(t);
                break;

              case 4:
                ln(t, t.stateNode.containerInfo);
                break;

              case 10:
                Ct(t, t.memoizedProps.value);
                break;

              case 13:
                if (null !== t.memoizedState) return 0 !== (r = t.child.childExpirationTime) && r >= n ? vr(e, t, n) : (ze(cn, 1 & cn.current), null !== (t = Pr(e, t, n)) ? t.sibling : null);
                ze(cn, 1 & cn.current);
                break;

              case 19:
                if (r = t.childExpirationTime >= n, 0 != (64 & e.effectTag)) {
                  if (r) return xr(e, t, n);
                  t.effectTag |= 64;
                }

                if (null !== (i = t.memoizedState) && (i.rendering = null, i.tail = null), ze(cn, cn.current), !r) return null;
            }

            return Pr(e, t, n);
          }

          rr = !1;
        }
      } else rr = !1;

      switch (t.expirationTime = 0, t.tag) {
        case 2:
          if (r = t.type, null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), e = t.pendingProps, i = Fe(t, Oe.current), It(t, n), i = xn(null, t, r, e, i, n), t.effectTag |= 1, "object" == typeof i && null !== i && "function" == typeof i.render && void 0 === i.$$typeof) {
            if (t.tag = 1, t.memoizedState = null, t.updateQueue = null, Ue(r)) {
              var l = !0;
              He(t);
            } else l = !1;

            t.memoizedState = null !== i.state && void 0 !== i.state ? i.state : null, zt(t);
            var o = r.getDerivedStateFromProps;
            "function" == typeof o && Lt(t, r, o, e), i.updater = Ht, t.stateNode = i, i._reactInternalFiber = t, qt(t, r, e, n), t = fr(null, t, r, !0, l, n);
          } else t.tag = 0, ir(null, t, i, n), t = t.child;

          return t;

        case 16:
          e: {
            if (i = t.elementType, null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), e = t.pendingProps, function (e) {
              if (-1 === e._status) {
                e._status = 0;
                var t = e._ctor;
                t = t(), e._result = t, t.then(function (t) {
                  0 === e._status && (t = t.default, e._status = 1, e._result = t);
                }, function (t) {
                  0 === e._status && (e._status = 2, e._result = t);
                });
              }
            }(i), 1 !== i._status) throw i._result;

            switch (i = i._result, t.type = i, l = t.tag = function (e) {
              if ("function" == typeof e) return cl(e) ? 1 : 0;

              if (null != e) {
                if ((e = e.$$typeof) === y) return 11;
                if (e === T) return 14;
              }

              return 2;
            }(i), e = Tt(i, e), l) {
              case 0:
                t = cr(null, t, i, e, n);
                break e;

              case 1:
                t = sr(null, t, i, e, n);
                break e;

              case 11:
                t = lr(null, t, i, e, n);
                break e;

              case 14:
                t = ar(null, t, i, Tt(i.type, e), r, n);
                break e;
            }

            throw Error(a(306, i, ""));
          }

          return t;

        case 0:
          return r = t.type, i = t.pendingProps, cr(e, t, r, i = t.elementType === r ? i : Tt(r, i), n);

        case 1:
          return r = t.type, i = t.pendingProps, sr(e, t, r, i = t.elementType === r ? i : Tt(r, i), n);

        case 3:
          if (dr(t), r = t.updateQueue, null === e || null === r) throw Error(a(282));
          if (r = t.pendingProps, i = null !== (i = t.memoizedState) ? i.element : null, At(e, t), Ft(t, r, null, n), (r = t.memoizedState.element) === i) tr(), t = Pr(e, t, n);else {
            if ((i = t.stateNode.hydrate) && (V ? (Vn = xe(t.stateNode.containerInfo), $n = t, i = Yn = !0) : i = !1), i) for (n = Jt(t, null, r, n), t.child = n; n;) {
              n.effectTag = -3 & n.effectTag | 1024, n = n.sibling;
            } else ir(e, t, r, n), tr();
            t = t.child;
          }
          return t;

        case 5:
          return on(t), null === e && Jn(t), r = t.type, i = t.pendingProps, l = null !== e ? e.memoizedProps : null, o = i.children, M(r, i) ? o = null : null !== l && M(r, l) && (t.effectTag |= 16), ur(e, t), 4 & t.mode && 1 !== n && Q(r, i) ? (t.expirationTime = t.childExpirationTime = 1, t = null) : (ir(e, t, o, n), t = t.child), t;

        case 6:
          return null === e && Jn(t), null;

        case 13:
          return vr(e, t, n);

        case 4:
          return ln(t, t.stateNode.containerInfo), r = t.pendingProps, null === e ? t.child = Gt(t, null, r, n) : ir(e, t, r, n), t.child;

        case 11:
          return r = t.type, i = t.pendingProps, lr(e, t, r, i = t.elementType === r ? i : Tt(r, i), n);

        case 7:
          return ir(e, t, t.pendingProps, n), t.child;

        case 8:
        case 12:
          return ir(e, t, t.pendingProps.children, n), t.child;

        case 10:
          e: {
            if (r = t.type._context, i = t.pendingProps, o = t.memoizedProps, Ct(t, l = i.value), null !== o) {
              var u = o.value;

              if (0 === (l = yt(u, l) ? 0 : 0 | ("function" == typeof r._calculateChangedBits ? r._calculateChangedBits(u, l) : 1073741823))) {
                if (o.children === i.children && !je.current) {
                  t = Pr(e, t, n);
                  break e;
                }
              } else for (null !== (u = t.child) && (u.return = t); null !== u;) {
                var c = u.dependencies;

                if (null !== c) {
                  o = u.child;

                  for (var s = c.firstContext; null !== s;) {
                    if (s.context === r && 0 != (s.observedBits & l)) {
                      1 === u.tag && ((s = Ot(n, null)).tag = 2, jt(u, s)), u.expirationTime < n && (u.expirationTime = n), null !== (s = u.alternate) && s.expirationTime < n && (s.expirationTime = n), kt(u.return, n), c.expirationTime < n && (c.expirationTime = n);
                      break;
                    }

                    s = s.next;
                  }
                } else o = 10 === u.tag && u.type === t.type ? null : u.child;

                if (null !== o) o.return = u;else for (o = u; null !== o;) {
                  if (o === t) {
                    o = null;
                    break;
                  }

                  if (null !== (u = o.sibling)) {
                    u.return = o.return, o = u;
                    break;
                  }

                  o = o.return;
                }
                u = o;
              }
            }

            ir(e, t, i.children, n), t = t.child;
          }

          return t;

        case 9:
          return i = t.type, r = (l = t.pendingProps).children, It(t, n), r = r(i = Rt(i, l.unstable_observedBits)), t.effectTag |= 1, ir(e, t, r, n), t.child;

        case 14:
          return l = Tt(i = t.type, t.pendingProps), ar(e, t, i, l = Tt(i.type, l), r, n);

        case 15:
          return or(e, t, t.type, t.pendingProps, r, n);

        case 17:
          return r = t.type, i = t.pendingProps, i = t.elementType === r ? i : Tt(r, i), null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), t.tag = 1, Ue(r) ? (e = !0, He(t)) : e = !1, It(t, n), Bt(t, r, i), qt(t, r, i, n), fr(null, t, r, !0, e, n);

        case 19:
          return xr(e, t, n);
      }

      throw Error(a(156, t.tag));
    };

    var il = {
      current: !1
    },
        ll = null,
        al = null;

    function ol(e, t, n, r) {
      this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.effectTag = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childExpirationTime = this.expirationTime = 0, this.alternate = null;
    }

    function ul(e, t, n, r) {
      return new ol(e, t, n, r);
    }

    function cl(e) {
      return !(!(e = e.prototype) || !e.isReactComponent);
    }

    function sl(e, t) {
      var n = e.alternate;
      return null === n ? ((n = ul(e.tag, t, e.key, e.mode)).elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.effectTag = 0, n.nextEffect = null, n.firstEffect = null, n.lastEffect = null), n.childExpirationTime = e.childExpirationTime, n.expirationTime = e.expirationTime, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = null === t ? null : {
        expirationTime: t.expirationTime,
        firstContext: t.firstContext,
        responders: t.responders
      }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n;
    }

    function fl(e, t, n, r, i, l) {
      var o = 2;
      if (r = e, "function" == typeof e) cl(e) && (o = 1);else if ("string" == typeof e) o = 5;else e: switch (e) {
        case f:
          return dl(n.children, i, l, t);

        case g:
          o = 8, i |= 7;
          break;

        case d:
          o = 8, i |= 1;
          break;

        case p:
          return (e = ul(12, n, t, 8 | i)).elementType = p, e.type = p, e.expirationTime = l, e;

        case v:
          return (e = ul(13, n, t, i)).type = v, e.elementType = v, e.expirationTime = l, e;

        case b:
          return (e = ul(19, n, t, i)).elementType = b, e.expirationTime = l, e;

        default:
          if ("object" == typeof e && null !== e) switch (e.$$typeof) {
            case m:
              o = 10;
              break e;

            case h:
              o = 9;
              break e;

            case y:
              o = 11;
              break e;

            case T:
              o = 14;
              break e;

            case x:
              o = 16, r = null;
              break e;

            case P:
              o = 22;
              break e;
          }
          throw Error(a(130, null == e ? e : typeof e, ""));
      }
      return (t = ul(o, n, t, i)).elementType = e, t.type = r, t.expirationTime = l, t;
    }

    function dl(e, t, n, r) {
      return (e = ul(7, e, r, t)).expirationTime = n, e;
    }

    function pl(e, t, n) {
      return (e = ul(6, e, null, t)).expirationTime = n, e;
    }

    function ml(e, t, n) {
      return (t = ul(4, null !== e.children ? e.children : [], e.key, t)).expirationTime = n, t.stateNode = {
        containerInfo: e.containerInfo,
        pendingChildren: null,
        implementation: e.implementation
      }, t;
    }

    function hl(e, t, n) {
      this.tag = t, this.current = null, this.containerInfo = e, this.pingCache = this.pendingChildren = null, this.finishedExpirationTime = 0, this.finishedWork = null, this.timeoutHandle = B, this.pendingContext = this.context = null, this.hydrate = n, this.callbackNode = null, this.callbackPriority = 90, this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
    }

    function gl(e, t) {
      var n = e.firstSuspendedTime;
      return e = e.lastSuspendedTime, 0 !== n && n >= t && e <= t;
    }

    function yl(e, t) {
      var n = e.firstSuspendedTime,
          r = e.lastSuspendedTime;
      n < t && (e.firstSuspendedTime = t), (r > t || 0 === n) && (e.lastSuspendedTime = t), t <= e.lastPingedTime && (e.lastPingedTime = 0), t <= e.lastExpiredTime && (e.lastExpiredTime = 0);
    }

    function vl(e, t) {
      t > e.firstPendingTime && (e.firstPendingTime = t);
      var n = e.firstSuspendedTime;
      0 !== n && (t >= n ? e.firstSuspendedTime = e.lastSuspendedTime = e.nextKnownPendingLevel = 0 : t >= e.lastSuspendedTime && (e.lastSuspendedTime = t + 1), t > e.nextKnownPendingLevel && (e.nextKnownPendingLevel = t));
    }

    function bl(e, t) {
      var n = e.lastExpiredTime;
      (0 === n || n > t) && (e.lastExpiredTime = t);
    }

    var Tl = null;

    function xl(e) {
      var t = e._reactInternalFiber;

      if (void 0 === t) {
        if ("function" == typeof e.render) throw Error(a(188));
        throw Error(a(268, Object.keys(e)));
      }

      return null === (e = I(t)) ? null : e.stateNode;
    }

    function Pl(e, t) {
      null !== (e = e.memoizedState) && null !== e.dehydrated && e.retryTime < t && (e.retryTime = t);
    }

    function El(e, t) {
      Pl(e, t), (e = e.alternate) && Pl(e, t);
    }

    var Sl = o.IsSomeRendererActing,
        wl = "function" == typeof l.unstable_flushAllWithoutAsserting,
        Cl = l.unstable_flushAllWithoutAsserting || function () {
      for (var e = !1; Zi();) {
        e = !0;
      }

      return e;
    };

    function _l(t) {
      try {
        Cl(), function (t) {
          if (null === Tl) try {
            var n = ("require" + Math.random()).slice(0, 7);
            Tl = (e && e[n])("timers").setImmediate;
          } catch (e) {
            Tl = function Tl(e) {
              var t = new MessageChannel();
              t.port1.onmessage = e, t.port2.postMessage(void 0);
            };
          }
          Tl(t);
        }(function () {
          Cl() ? _l(t) : t();
        });
      } catch (e) {
        t(e);
      }
    }

    var kl = 0,
        Il = !1,
        Rl = {
      __proto__: null,
      createContainer: function createContainer(e, t, n) {
        return e = new hl(e, t, n), t = ul(3, null, null, 2 === t ? 7 : 1 === t ? 3 : 0), e.current = t, t.stateNode = e, zt(t), e;
      },
      updateContainer: function updateContainer(e, t, n, r) {
        var i = t.current,
            l = zi(),
            o = Mt.suspense;
        l = Ai(l, i, o);

        e: if (n) {
          t: {
            if (C(n = n._reactInternalFiber) !== n || 1 !== n.tag) throw Error(a(170));
            var u = n;

            do {
              switch (u.tag) {
                case 3:
                  u = u.stateNode.context;
                  break t;

                case 1:
                  if (Ue(u.type)) {
                    u = u.stateNode.__reactInternalMemoizedMergedChildContext;
                    break t;
                  }

              }

              u = u.return;
            } while (null !== u);

            throw Error(a(171));
          }

          if (1 === n.tag) {
            var c = n.type;

            if (Ue(c)) {
              n = Le(n, c, u);
              break e;
            }
          }

          n = u;
        } else n = Ae;

        return null === t.context ? t.context = n : t.pendingContext = n, (t = Ot(l, o)).payload = {
          element: e
        }, null !== (r = void 0 === r ? null : r) && (t.callback = r), jt(i, t), Oi(i, l), l;
      },
      batchedEventUpdates: function batchedEventUpdates(e, t) {
        var n = ui;
        ui |= 2;

        try {
          return e(t);
        } finally {
          (ui = n) === Jr && mt();
        }
      },
      batchedUpdates: Mi,
      unbatchedUpdates: function unbatchedUpdates(e, t) {
        var n = ui;
        ui &= -2, ui |= Zr;

        try {
          return e(t);
        } finally {
          (ui = n) === Jr && mt();
        }
      },
      deferredUpdates: function deferredUpdates(e) {
        return ft(97, e);
      },
      syncUpdates: function syncUpdates(e, t, n, r) {
        return ft(99, e.bind(null, t, n, r));
      },
      discreteUpdates: function discreteUpdates(e, t, n, r, i) {
        var l = ui;
        ui |= 4;

        try {
          return ft(98, e.bind(null, t, n, r, i));
        } finally {
          (ui = l) === Jr && mt();
        }
      },
      flushDiscreteUpdates: function flushDiscreteUpdates() {
        (ui & (1 | ei | ti)) === Jr && (function () {
          if (null !== ki) {
            var e = ki;
            ki = null, e.forEach(function (e, t) {
              bl(t, e), Fi(t);
            }), mt();
          }
        }(), Zi());
      },
      flushControlled: function flushControlled(e) {
        var t = ui;
        ui |= 1;

        try {
          ft(99, e);
        } finally {
          (ui = t) === Jr && mt();
        }
      },
      flushSync: Qi,
      flushPassiveEffects: Zi,
      IsThisRendererActing: il,
      getPublicRootInstance: function getPublicRootInstance(e) {
        if (!(e = e.current).child) return null;

        switch (e.child.tag) {
          case 5:
            return R(e.child.stateNode);

          default:
            return e.child.stateNode;
        }
      },
      attemptSynchronousHydration: function attemptSynchronousHydration(e) {
        switch (e.tag) {
          case 3:
            var t = e.stateNode;
            t.hydrate && function (e, t) {
              bl(e, t), Fi(e), (ui & (ei | ti)) === Jr && mt();
            }(t, t.firstPendingTime);
            break;

          case 13:
            Qi(function () {
              return Oi(e, 1073741823);
            }), t = gt(zi(), 150, 100), El(e, t);
        }
      },
      attemptUserBlockingHydration: function attemptUserBlockingHydration(e) {
        if (13 === e.tag) {
          var t = gt(zi(), 150, 100);
          Oi(e, t), El(e, t);
        }
      },
      attemptContinuousHydration: function attemptContinuousHydration(e) {
        13 === e.tag && (Oi(e, 3), El(e, 3));
      },
      attemptHydrationAtCurrentPriority: function attemptHydrationAtCurrentPriority(e) {
        if (13 === e.tag) {
          var t = zi();
          Oi(e, t = Ai(t, e, null)), El(e, t);
        }
      },
      findHostInstance: xl,
      findHostInstanceWithWarning: function findHostInstanceWithWarning(e) {
        return xl(e);
      },
      findHostInstanceWithNoPortals: function findHostInstanceWithNoPortals(e) {
        return null === (e = function (e) {
          if (!(e = k(e))) return null;

          for (var t = e;;) {
            if (5 === t.tag || 6 === t.tag) return t;
            if (t.child && 4 !== t.tag) t.child.return = t, t = t.child;else {
              if (t === e) break;

              for (; !t.sibling;) {
                if (!t.return || t.return === e) return null;
                t = t.return;
              }

              t.sibling.return = t.return, t = t.sibling;
            }
          }

          return null;
        }(e)) ? null : 20 === e.tag ? e.stateNode.instance : e.stateNode;
      },
      shouldSuspend: function shouldSuspend() {
        return !1;
      },
      injectIntoDevTools: function injectIntoDevTools(e) {
        var t = e.findFiberByHostInstance;
        return function (e) {
          if ("undefined" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
          var t = __REACT_DEVTOOLS_GLOBAL_HOOK__;
          if (t.isDisabled || !t.supportsFiber) return !0;

          try {
            var n = t.inject(e);
            ll = function ll(e) {
              try {
                t.onCommitFiberRoot(n, e, void 0, 64 == (64 & e.current.effectTag));
              } catch (e) {}
            }, al = function al(e) {
              try {
                t.onCommitFiberUnmount(n, e);
              } catch (e) {}
            };
          } catch (e) {}

          return !0;
        }(r({}, e, {
          overrideHookState: null,
          overrideProps: null,
          setSuspenseHandler: null,
          scheduleUpdate: null,
          currentDispatcherRef: o.ReactCurrentDispatcher,
          findHostInstanceByFiber: function findHostInstanceByFiber(e) {
            return null === (e = I(e)) ? null : e.stateNode;
          },
          findFiberByHostInstance: function findFiberByHostInstance(e) {
            return t ? t(e) : null;
          },
          findHostInstancesForRefresh: null,
          scheduleRefresh: null,
          scheduleRoot: null,
          setRefreshHandler: null,
          getCurrentFiber: null
        }));
      },
      act: function act(e) {
        function t() {
          kl--, Sl.current = n, il.current = r;
        }

        !1 === Il && (Il = !0, console.error("act(...) is not supported in production builds of React, and might not behave as expected.")), kl++;
        var n = Sl.current,
            r = il.current;
        Sl.current = !0, il.current = !0;

        try {
          var i = Mi(e);
        } catch (e) {
          throw t(), e;
        }

        if (null !== i && "object" == typeof i && "function" == typeof i.then) return {
          then: function then(e, r) {
            i.then(function () {
              1 < kl || !0 === wl && !0 === n ? (t(), e()) : _l(function (n) {
                t(), n ? r(n) : e();
              });
            }, function (e) {
              t(), r(e);
            });
          }
        };

        try {
          1 !== kl || !1 !== wl && !1 !== n || Cl(), t();
        } catch (e) {
          throw t(), e;
        }

        return {
          then: function then(e) {
            e();
          }
        };
      }
    },
        Nl = Rl && Rl.default || Rl;
    e.exports = Nl.default || Nl;
    var zl = e.exports;
    return e.exports = t, zl;
  };
}),
    reactReconciler = createCommonjsModule(function (e) {
  e.exports = reactReconciler_production_min;
}),
    emptyObject = {},
    emptyObject_1 = emptyObject,
    global$1 = "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {};

function defaultSetTimout() {
  throw new Error("setTimeout has not been defined");
}

function defaultClearTimeout() {
  throw new Error("clearTimeout has not been defined");
}

var cachedSetTimeout = defaultSetTimout,
    cachedClearTimeout = defaultClearTimeout;

function runTimeout(e) {
  if (cachedSetTimeout === setTimeout) return setTimeout(e, 0);
  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) return cachedSetTimeout = setTimeout, setTimeout(e, 0);

  try {
    return cachedSetTimeout(e, 0);
  } catch (t) {
    try {
      return cachedSetTimeout.call(null, e, 0);
    } catch (t) {
      return cachedSetTimeout.call(this, e, 0);
    }
  }
}

function runClearTimeout(e) {
  if (cachedClearTimeout === clearTimeout) return clearTimeout(e);
  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) return cachedClearTimeout = clearTimeout, clearTimeout(e);

  try {
    return cachedClearTimeout(e);
  } catch (t) {
    try {
      return cachedClearTimeout.call(null, e);
    } catch (t) {
      return cachedClearTimeout.call(this, e);
    }
  }
}

"function" == typeof global$1.setTimeout && (cachedSetTimeout = setTimeout), "function" == typeof global$1.clearTimeout && (cachedClearTimeout = clearTimeout);
var currentQueue,
    queue = [],
    draining = !1,
    queueIndex = -1;

function cleanUpNextTick() {
  draining && currentQueue && (draining = !1, currentQueue.length ? queue = currentQueue.concat(queue) : queueIndex = -1, queue.length && drainQueue());
}

function drainQueue() {
  if (!draining) {
    var e = runTimeout(cleanUpNextTick);
    draining = !0;

    for (var t = queue.length; t;) {
      for (currentQueue = queue, queue = []; ++queueIndex < t;) {
        currentQueue && currentQueue[queueIndex].run();
      }

      queueIndex = -1, t = queue.length;
    }

    currentQueue = null, draining = !1, runClearTimeout(e);
  }
}

function nextTick(e) {
  var t = new Array(arguments.length - 1);
  if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
    t[n - 1] = arguments[n];
  }
  queue.push(new Item(e, t)), 1 !== queue.length || draining || runTimeout(drainQueue);
}

function Item(e, t) {
  this.fun = e, this.array = t;
}

Item.prototype.run = function () {
  this.fun.apply(null, this.array);
};

var title = "browser",
    platform = "browser",
    browser = !0,
    env = {},
    argv = [],
    version = "",
    versions = {},
    release = {},
    config = {};

function noop() {}

var on = noop,
    addListener = noop,
    once = noop,
    off = noop,
    removeListener = noop,
    removeAllListeners = noop,
    emit = noop;

function binding(e) {
  throw new Error("process.binding is not supported");
}

function cwd() {
  return "/";
}

function chdir(e) {
  throw new Error("process.chdir is not supported");
}

function umask() {
  return 0;
}

var performance$1 = global$1.performance || {},
    performanceNow = performance$1.now || performance$1.mozNow || performance$1.msNow || performance$1.oNow || performance$1.webkitNow || function () {
  return new Date().getTime();
};

function hrtime(e) {
  var t = .001 * performanceNow.call(performance$1),
      n = Math.floor(t),
      r = Math.floor(t % 1 * 1e9);
  return e && (n -= e[0], (r -= e[1]) < 0 && (n--, r += 1e9)), [n, r];
}

var startTime = new Date();

function uptime() {
  return (new Date() - startTime) / 1e3;
}

var process = {
  nextTick: nextTick,
  title: title,
  browser: browser,
  env: env,
  argv: argv,
  version: version,
  versions: versions,
  on: on,
  addListener: addListener,
  once: once,
  off: off,
  removeListener: removeListener,
  removeAllListeners: removeAllListeners,
  emit: emit,
  binding: binding,
  cwd: cwd,
  chdir: chdir,
  umask: umask,
  hrtime: hrtime,
  platform: platform,
  release: release,
  config: config,
  uptime: uptime
},
    performanceNow$1 = createCommonjsModule(function (e) {
  (function () {
    var t, n, r, i, l, a;
    "undefined" != typeof performance && null !== performance && performance.now ? e.exports = function () {
      return performance.now();
    } : null != process && process.hrtime ? (e.exports = function () {
      return (t() - l) / 1e6;
    }, n = process.hrtime, i = (t = function t() {
      var e;
      return 1e9 * (e = n())[0] + e[1];
    })(), a = 1e9 * process.uptime(), l = i - a) : Date.now ? (e.exports = function () {
      return Date.now() - r;
    }, r = Date.now()) : (e.exports = function () {
      return new Date().getTime() - r;
    }, r = new Date().getTime());
  }).call(commonjsGlobal);
}),
    TYPES = {
  BITMAP_TEXT: "BitmapText",
  CONTAINER: "Container",
  GRAPHICS: "Graphics",
  NINE_SLICE_PLANE: "NineSlicePlane",
  PARTICLE_CONTAINER: "ParticleContainer",
  SPRITE: "Sprite",
  TEXT: "Text",
  TILING_SPRITE: "TilingSprite"
};

function defaultApplyProps(e, t, n) {
  Object.keys(t).concat(Object.keys(n)).filter(unique).filter(not(includingReservedProps)).forEach(function (t) {
    var r = DEFAULT_PROPS[t],
        i = e[t],
        l = n[t];
    void 0 !== l ? setPixiValue(e, t, l) : void 0 !== i && void 0 !== r ? (warning_1(!1, "setting default value: ".concat(t, " was ").concat(i, " is ").concat(l, " for %O"), e), setPixiValue(e, t, r)) : warning_1(!1, "ignoring prop: ".concat(t, " was ").concat(e[t], " is ").concat(l, " for %O"), e);
  });
}

function applyProps(e, t, n) {
  "function" == typeof e._customApplyProps ? e._customApplyProps(e, t, n) : defaultApplyProps(e, t, n);
}

function diffProps(e, t, n, r, i) {
  var l,
      a = null,
      o = n,
      u = r;

  for (l in o) {
    !u.hasOwnProperty(l) && o.hasOwnProperty(l) && null != o[l] && (l === CHILDREN || (a = a || []).push(l, null));
  }

  for (l in u) {
    var c = u[l],
        s = null != o ? o[l] : void 0;
    !u.hasOwnProperty(l) || c === s || null == c && null == s || l === CHILDREN || (a = a || []).push(l, c);
  }

  return a;
}

function appendChild(e, t) {
  e.removeChild(t), e.addChild(t), "function" == typeof t._customDidAttach && t._customDidAttach(t);
}

function removeChild(e, t) {
  "function" == typeof t._customWillDetach && t._customWillDetach(t), e.removeChild(t), t.destroy({
    children: !0
  });
}

function insertBefore(e, t, n) {
  invariant_1(t !== n, "ReactPixiFiber cannot insert node before itself"), -1 !== e.children.indexOf(t) && e.removeChild(t);
  var r = e.getChildIndex(n);
  e.addChildAt(t, r);
}

function commitUpdate(e, t, n, r, i, l) {
  if (isInjectedType(n)) applyProps(e, r, i);else {
    var a = including(t.filter(function (e, t) {
      return t % 2 == 0;
    }));
    applyProps(e, filterByKey(r, a), filterByKey(i, a));
  }
}

function createInstance(e, t, n) {
  var r;

  switch (e) {
    case TYPES.BITMAP_TEXT:
      var i = void 0 !== t.style ? t.style : {
        align: t.align,
        font: t.font,
        tint: t.tint
      };

      try {
        r = new PIXI.extras.BitmapText(t.text, i);
      } catch (e) {
        r = new PIXI.BitmapText(t.text, i);
      }

      break;

    case TYPES.CONTAINER:
      r = new PIXI.Container();
      break;

    case TYPES.GRAPHICS:
      r = new PIXI.Graphics();
      break;

    case TYPES.NINE_SLICE_PLANE:
      try {
        r = new PIXI.mesh.NineSlicePlane(t.texture, t.leftWidth, t.topHeight, t.rightWidth, t.bottomHeight);
      } catch (e) {
        r = new PIXI.NineSlicePlane(t.texture, t.leftWidth, t.topHeight, t.rightWidth, t.bottomHeight);
      }

      break;

    case TYPES.PARTICLE_CONTAINER:
      try {
        r = new PIXI.particles.ParticleContainer(t.maxSize, t.properties, t.batchSize, t.autoResize);
      } catch (e) {
        r = new PIXI.ParticleContainer(t.maxSize, t.properties, t.batchSize, t.autoResize);
      }

      break;

    case TYPES.SPRITE:
      r = new PIXI.Sprite(t.texture);
      break;

    case TYPES.TEXT:
      r = new PIXI.Text(t.text, t.style, t.canvas);
      break;

    case TYPES.TILING_SPRITE:
      try {
        r = new PIXI.extras.TilingSprite(t.texture, t.width, t.height);
      } catch (e) {
        r = new PIXI.TilingSprite(t.texture, t.width, t.height);
      }

      break;

    default:
      r = createInjectedTypeInstance(e, t, n, defaultApplyProps);
  }

  return invariant_1(r, "ReactPixiFiber does not support the type: `%s`.", e), applyProps(r, {}, t), r;
}

function createTextInstance(e, t, n) {
  invariant_1(!1, "ReactPixiFiber does not support text instances. Use Text component instead.");
}

function finalizeInitialChildren(e, t, n, r, i) {
  return !1;
}

function getChildHostContext(e, t) {
  return emptyObject_1;
}

function getRootHostContext(e) {
  return emptyObject_1;
}

function getPublicInstance(e) {
  return e;
}

function prepareForCommit() {}

function prepareUpdate(e, t, n, r, i, l) {
  return diffProps(e, t, n, r, i);
}

function resetAfterCommit() {}

function resetTextContent(e) {}

function shouldDeprioritizeSubtree(e, t) {
  var n = void 0 === t.alpha || t.alpha > 0,
      r = void 0 === t.renderable || !0 === t.renderable,
      i = void 0 === t.visible || !0 === t.visible;
  return !(n && r && i);
}

function shouldSetTextContent(e, t) {
  return !1;
}

function commitTextUpdate(e, t, n) {}

function commitMount(e, t, n) {}

function hideInstance(e) {
  e.visible = !1;
}

function unhideInstance(e, t) {
  e.visible = void 0 === t.visible || t.visible;
}

function hideTextInstance(e) {}

function unhideTextInstance(e, t) {}

var supportsMutation = !0,
    hostConfig = {
  appendChild: appendChild,
  appendChildToContainer: appendChild,
  appendInitialChild: appendChild,
  cancelPassiveEffects: scheduler.unstable_cancelCallback,
  commitMount: commitMount,
  commitTextUpdate: commitTextUpdate,
  commitUpdate: commitUpdate,
  createInstance: createInstance,
  createTextInstance: createTextInstance,
  finalizeInitialChildren: finalizeInitialChildren,
  getChildHostContext: getChildHostContext,
  getRootHostContext: getRootHostContext,
  getPublicInstance: getPublicInstance,
  hideInstance: hideInstance,
  hideTextInstance: hideTextInstance,
  insertBefore: insertBefore,
  insertInContainerBefore: insertBefore,
  now: performanceNow$1,
  prepareForCommit: prepareForCommit,
  prepareUpdate: prepareUpdate,
  removeChild: removeChild,
  removeChildFromContainer: removeChild,
  resetAfterCommit: resetAfterCommit,
  resetTextContent: resetTextContent,
  scheduleDeferredCallback: scheduler.unstable_scheduleCallback,
  schedulePassiveEffects: scheduler.unstable_scheduleCallback,
  shouldDeprioritizeSubtree: shouldDeprioritizeSubtree,
  shouldSetTextContent: shouldSetTextContent,
  supportsMutation: supportsMutation,
  unhideInstance: unhideInstance,
  unhideTextInstance: unhideTextInstance
},
    ReactPixiFiberAsPrimaryRenderer = reactReconciler(_objectSpread({}, hostConfig, {
  isPrimaryRenderer: !0
})),
    ReactPixiFiberAsSecondaryRenderer = reactReconciler(_objectSpread({}, hostConfig, {
  isPrimaryRenderer: !1
})),
    unstable_batchedUpdates = ReactPixiFiberAsPrimaryRenderer.batchedUpdates;

function usePixiApp() {
  return React.useContext(exports.AppContext);
}

function usePixiTicker(e) {
  var t = usePixiApp().ticker;
  React.useEffect(function () {
    return t.add(e), function () {
      t.remove(e);
    };
  }, [e, t]);
}

function usePreviousProps(e) {
  var t = React.useRef({});
  return React.useEffect(function () {
    t.current = e;
  }), t.current;
}

function getCanvas(e, t) {
  var n = e.app,
      r = e.options;
  if (void 0 !== r && r.view) return null;
  if (n instanceof PIXI.Application) return null;
  var i = getCanvasProps(e);
  return React__default.createElement("canvas", _extends({
    ref: t
  }, i));
}

function usePixiAppCreator(e) {
  var t = e.app;
  invariant_1(null == t || t instanceof PIXI.Application, "Provided `app` has to be an instance of PIXI.Application");

  var n = e.options,
      r = e.width,
      i = e.height,
      l = _slicedToArray(React.useState(null), 2),
      a = l[0],
      o = l[1],
      u = React.useRef(),
      c = getCanvas(e, u);

  return React.useLayoutEffect(function () {
    var e = createUnmount(ReactPixiFiberAsSecondaryRenderer),
        l = u.current,
        a = t || createPixiApplication(_objectSpread({
      height: i,
      width: r,
      view: l
    }, n));
    return o(a), function () {
      e(a.stage), t instanceof PIXI.Application || a.destroy();
    };
  }, [t, n, r, i]), {
    app: a,
    canvas: c
  };
}

var render = createRender(ReactPixiFiberAsSecondaryRenderer),
    unmount = createUnmount(ReactPixiFiberAsSecondaryRenderer),
    includingDisplayObjectProps$1 = including(Object.keys(DEFAULT_PROPS).concat(EVENT_PROPS)),
    applyUpdate = function applyUpdate(e, t, n) {
  var r = React__default.createElement(AppProvider, {
    app: e
  }, t.children),
      i = getDisplayObjectProps(t);
  applyProps(e.stage, {}, i), "object" === _typeof(n) ? render(r, e.stage, void 0, n) : render(r, e.stage);
},
    getDimensions = function getDimensions(e) {
  var t = e.options,
      n = e.width,
      r = e.height;
  return [t && t.width || n, t && t.height || r];
},
    resizeRenderer = function resizeRenderer(e, t, n) {
  var r = _slicedToArray(getDimensions(t), 2),
      i = r[0],
      l = r[1],
      a = _slicedToArray(getDimensions(n), 2),
      o = a[0],
      u = a[1];

  u === l && o === i || e.renderer.resize(o, u);
};

function createStageFunction() {
  function e(e) {
    var t = e.app,
        n = usePixiAppCreator(e),
        r = n.app,
        i = n.canvas,
        l = usePreviousProps(e);
    return React.useLayoutEffect(function () {
      r && r.stage && (applyUpdate(r, e), t instanceof PIXI.Application || resizeRenderer(r, l, e));
    }), i;
  }

  return e.propTypes = propTypes$1, e;
}

function createStageClass() {
  var e = function (e) {
    function t() {
      return _classCallCheck(this, t), _possibleConstructorReturn(this, _getPrototypeOf(t).apply(this, arguments));
    }

    return _inherits(t, React__default.Component), _createClass(t, [{
      key: "componentDidMount",
      value: function value() {
        var e = this.props,
            t = e.app,
            n = e.height,
            r = e.options,
            i = e.width,
            l = this._canvas;
        invariant_1(null == t || t instanceof PIXI.Application, "Provided `app` has to be an instance of PIXI.Application"), this._app = t || createPixiApplication(_objectSpread({
          height: n,
          width: i,
          view: l
        }, r)), applyUpdate(this._app, this.props, this);
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e) {
        var t = this.props.app;
        applyUpdate(this._app, this.props, this), t instanceof PIXI.Application || resizeRenderer(this._app, e, this.props);
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        var e = this.props.app;
        unmount(this._app.stage), e instanceof PIXI.Application || this._app.destroy();
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
            t = this.props,
            n = t.app,
            r = t.options;
        if (void 0 !== r && r.view) return null;
        if (n instanceof PIXI.Application) return null;
        var i = getCanvasProps(this.props);
        return React__default.createElement("canvas", _extends({
          ref: function ref(t) {
            return e._canvas = t;
          }
        }, i));
      }
    }]), t;
  }();

  return e.propTypes = propTypes$1, e;
}

var Stage = "function" == typeof React.useState ? createStageFunction() : createStageClass(),
    render$1 = createRender(ReactPixiFiberAsPrimaryRenderer),
    unmount$1 = createUnmount(ReactPixiFiberAsPrimaryRenderer),
    BitmapText = TYPES.BITMAP_TEXT,
    Container = TYPES.CONTAINER,
    Graphics = TYPES.GRAPHICS,
    NineSlicePlane = TYPES.NINE_SLICE_PLANE,
    ParticleContainer = TYPES.PARTICLE_CONTAINER,
    Sprite = TYPES.SPRITE,
    Text = TYPES.TEXT,
    TilingSprite = TYPES.TILING_SPRITE;
exports.AppProvider = AppProvider, exports.CustomPIXIComponent = CustomPIXIComponent, exports.Stage = Stage, exports.applyProps = applyProps, exports.createStageClass = createStageClass, exports.render = render$1, exports.unmount = unmount$1, exports.withApp = withApp, exports.usePixiApp = usePixiApp, exports.usePixiTicker = usePixiTicker, exports.usePixiAppCreator = usePixiAppCreator, exports.unstable_batchedUpdates = unstable_batchedUpdates, exports.BitmapText = BitmapText, exports.Container = Container, exports.Graphics = Graphics, exports.NineSlicePlane = NineSlicePlane, exports.ParticleContainer = ParticleContainer, exports.Sprite = Sprite, exports.Text = Text, exports.TilingSprite = TilingSprite;